<template>
  <div class="main-container">
    <div class="container-wrapper converter-workspace">
      <div class="calcolatrice">
        <div
          class="contenitore-bilancio"
          :class="['contenitore', isShifted ? 'shift-left' : '']"
        >
          <!-- Titolo principale -->
          <div class="header">
            <span class="converter-title-icon" aria-hidden="true">
              <img
                src="/Pagina Convertitore/icona Bilanci Analitici trasparente.png"
                alt=""
              />
            </span>
            <h3 class="titleConvBilanci">
              Convertitore
              <br />
              <span class="titleprospetti">BILANCIO ANALITICO</span>
            </h3>
            <div class="current-plan-container">
              <div :class="['current-plan', currentPlan.toLowerCase()]">
                {{ currentPlan }}
              </div>
            </div>
          </div>
          <div class="headerButtons headersButtonsbilancio">
            <router-link to="/home" class="tool-button">
              <i
                title="Torna alla Home"
                class="fa-solid fa-house back backconv"
              ></i>
            </router-link>
            <router-link to="/home/store" class="tool-button">
              <i
                title="Acquista Coin"
                class="fa-solid fa-cart-shopping storeicon icons-conv"
              >
              </i>
            </router-link>
            <i
              title="Reset del convertitore"
              class="fa-solid fa-arrows-rotate refresh icons-conv"
              @click="refreshConversione"
            >
            </i>
          </div>
          <!-- Contenitore degli input -->
          <div class="input-container">
            <div class="converter-file-actions">
              <label for="fileInput" class="input-label input-label--file"
                >Seleziona file da convertire:</label
              >
              <button
                v-if="filePDF_URL"
                @click="openPDFPreview"
                class="btn btn-secondary anteprimapdf"
              >
                <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
                Visualizza PDF
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'excel'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--excel"
              >
                <i class="fa-solid fa-file-excel" aria-hidden="true"></i>
                Visualizza Excel
              </button>
              <button
                v-if="ExcelRows.length && fileType === 'csv'"
                @click="showExcelModal = true"
                class="anteprimaexcel anteprimaexcel--csv"
              >
                <i class="fa-solid fa-file-csv" aria-hidden="true"></i>
                Visualizza CSV
              </button>
            </div>
            <input
              id="fileInput"
              class="file-input"
              type="file"
              ref="fileInput"
              @change="handleFileChange"
              :disabled="fase2 || fase3 || calculating || calculating2"
            />
            <small class="converter-formats"
              >Formati supportati: PDF, CSV</small
            >
            <span class="softwaredetected" v-show="input_PC">
              <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
              <span class="softwaredetected-label"
                >Software contabile rilevato</span
              >
              <strong class="input_PC">{{ input_PC }}</strong>
            </span>
            <label for="outputSystem" class="input-label input-label--software">
              Software contabile di conversione:
            </label>
            <select
              v-model="output_PC"
              id="outputSystem"
              class="select-input"
              :disabled="fase2 || fase3 || calculating || calculating2"
            >
              <option disabled selected value="">Seleziona software</option>
              <option value="TEAMSYSTEM">TEAMSYSTEM</option>
              <option value="DATEV">DATEV</option>
              <option value="ZUCCHETTI">ZUCCHETTI</option>
              <option value="SEAC">SEAC</option>
              <option value="SISTEMI">SISTEMI</option>
              <!-- <option value="SISTEMI">SISTEMI</option> -->
            </select>
            <div
              v-if="output_PC === 'DATEV' || output_PC === 'TEAMSYSTEM'"
              class="container-checkbox"
              :title="
                ha(user, 'import_csv_diretto')
                  ? 'Genera il file CSV pronto per l\'importazione diretta nel tuo gestionale'
                  : 'Disponibile da piano Plus'
              "
            >
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="flag_csv_import"
                :disabled="
                  fase3 ||
                  calculating ||
                  calculating2 ||
                  !ha(user, 'import_csv_diretto')
                "
                id="csv-import-checkbox"
              />
              <label for="csv-import-checkbox" class="csv-label">
                File .csv per importazione diretta
                <span v-if="!ha(user, 'import_csv_diretto')" class="lock-icon">
                  <i class="fa-solid fa-lock"></i>
                </span>
              </label>
            </div>
            <!-- NUOVO – dettagli clienti/fornitori -->
            <div
              class="container-checkbox"
              title="Includi dettagli clienti/fornitori"
            >
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="flag_dettClientiFornitori"
                id="dett-clienti-fornitori-checkbox"
                :disabled="fase2 || fase3 || calculating || calculating2"
              />
              <label for="dett-clienti-fornitori-checkbox" class="csv-label">
                Dettaglio Clienti/Fornitori
              </label>
            </div>
            <!-- Checkbox per Versione partitaria -->
            <div class="container-checkbox" v-if="input_PC === 'SISTEMI'">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="flag_PARTITARIO"
                :disabled="fase2 || fase3 || calculating || calculating2"
              />
              <label>Estrazione con Partitario</label>
            </div>

            <button
              @click="fase_1_bilancio"
              :disabled="calculating || fase1 || fase2 || fase3"
              class="action-button"
            >
              <span v-if="calculating">
                <div class="spinner"></div>
                Elaborazione...
              </span>
              <span v-else
                ><i class="fa-solid fa-play"></i> Avvia conversione</span
              >
            </button>
            <div
              v-if="errorMessage"
              class="converter-error-alert"
              role="alert"
              aria-live="polite"
            >
              <i
                class="fa-solid fa-triangle-exclamation converter-error-alert__icon"
                aria-hidden="true"
              ></i>
              <div class="converter-error-alert__content">
                <strong>{{ errorAlertTitle }}</strong>
                <span>{{ errorMessage }}</span>
              </div>
            </div>
          </div>
          <ProcessingWaitNotice
            v-if="showDelayedMessage"
            :extended="delayedMessageUpdated"
          />
        </div>
      </div>
      <ConverterWelcomePanel
        v-if="!showResult"
        tone="bilancio"
        :description="'Importa i bilanci analitici da PDF o CSV e trasformali in dati\npronti per il tuo software contabile.'"
      />
      <div
        v-show="showResult"
        :class="[
          'result-container',
          'result-container--bilancio-analitico',
          showResult ? 'show' : '',
          { 'result-container--locked': tableInteractionLocked },
        ]"
        :aria-busy="tableInteractionLocked ? 'true' : 'false'"
        @beforeinput.capture="preventLockedTableInteraction"
        @click.capture="preventLockedTableInteraction"
        @change.capture="preventLockedTableInteraction"
        @input.capture="preventLockedTableInteraction"
        @keydown.capture="preventLockedTableInteraction"
        @focusin.capture="preventLockedTableInteraction"
      >
        <!--------------------- FASE 1 ---------------------->
        <div v-if="fase1" class="fase1">
          <h3 class="clienti-individuati title-conv">CLIENTE INDIVIDUATO</h3>
          <p class="numerofaseAttuale">Fase 1 di 3</p>
          <AdminMsFiscalCodeGenerator
            :clients="vettoreClienti"
            @apply-code="applyAdminMsFiscalCode"
          />
          <!-- Pulsante per espandere/ridurre la tabella -->
          <div class="response-message">
            <div class="divclient-table" :class="{ expanded: isTableExpanded }">
              <table
                class="client-table"
                :class="{ 'client-table-datev': output_PC === 'DATEV' }"
              >
                <thead>
                  <i
                    @click="toggleTableExpansion"
                    :class="
                      isTableExpanded
                        ? 'fa-solid fa-compress expand-button-clienti'
                        : 'fa-solid fa-expand expand-button-clienti'
                    "
                    title="Espandi / Comprimi Tabella"
                  ></i>
                  <tr>
                    <th v-if="settings.flag_mostra_codice_ditta">
                      Codice ditta
                    </th>
                    <th>Denominazione cliente</th>
                    <th>Data</th>
                    <th>Codice fiscale</th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Aziende
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(3)"
                      >
                        ✔
                      </button>
                    </th>
                    <th v-if="output_PC === 'DATEV'">
                      Piano dei Conti Lib. Prof.
                      <button
                        title="Seleziona l'intera colonna"
                        class="btn-select"
                        @click="selezionaColonna(4)"
                      >
                        ✔
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(cliente, index) in vettoreClienti" :key="index">
                    <!-- Codice ditta – sempre editabile -->
                    <td v-if="settings.flag_mostra_codice_ditta">
                      <input
                        type="text"
                        v-model.trim="cliente[0]"
                        placeholder="Inserisci Codice ditta"
                        title="Inserisci Codice ditta"
                        inputmode="numeric"
                        pattern="[0-9]*"
                        maxlength="8"
                        @input="
                          cliente[0] = $event.target.value.replace(
                            /[^0-9]/g,
                            ''
                          )
                        "
                        class="input-editable"
                        :class="{ 'input-valorizzato': cliente[0]?.trim() }"
                      />
                    </td>

                    <!-- Denominazione pulita -->
                    <td>
                      {{ getNome(cliente[1]) }}
                    </td>

                    <!-- Data estratta -->
                    <td>
                      <input
                        :value="dateBilancioInputs[index] || ''"
                        placeholder="GG/MM/AAAA"
                        title="Inserisci Data bilancio"
                        class="input-editable"
                        :class="{
                          'filled-input':
                            dateBilancioInputs[index] &&
                            isValidDateBilancio(dateBilancioInputs[index]),
                          'invalid-input': shouldShowInvalidDateBilancio(
                            dateBilancioInputs[index]
                          ),
                        }"
                        maxlength="10"
                        inputmode="numeric"
                        autocomplete="off"
                        @input="
                          handleDateBilancioInput(index, $event.target.value)
                        "
                        @blur="commitDateBilancio(index)"
                        @keydown.enter.prevent="$event.target.blur()"
                      />
                    </td>

                    <td>
                      <input
                        v-model.trim="cliente[4]"
                        placeholder="Inserisci Codice fiscale"
                        title="Inserisci Codice fiscale"
                        class="input-editable"
                        maxlength="16"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                        :class="{
                          'filled-input':
                            cliente[4] && cliente[4].trim() !== '',
                          'invalid-input':
                            cliente[4] && !isValidCodiceFiscale(cliente[4]),
                        }"
                        @input="formattaCFPI($event, cliente, index)"
                      />
                    </td>
                    <!-- Colonne DATEV esistenti -->
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-datev-' + index"
                        :value="1"
                        v-model="vettoreClienti[index][2]"
                      />
                    </td>
                    <td v-if="output_PC === 'DATEV'">
                      <input
                        type="radio"
                        :name="'scelta-datev-' + index"
                        :value="2"
                        v-model="vettoreClienti[index][2]"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="conversion-summary-box"
              :class="{
                'normal-margin':
                  creditiDisponibili &lt; numeroClienti * creditiPerBilancio,
                'extra-margin':
                  creditiDisponibili >= numeroClienti * creditiPerBilancio,
              }"
            >
              <div class="summary-row">
                <span class="label">Clienti individuati:</span>
                <span class="value">{{ numeroClienti }}</span>
              </div>
              <div class="summary-row">
                <span class="label">Coin disponibili:</span>
                <span class="value">{{ creditiDisponibili }}</span>
              </div>
              <div class="summary-row">
                <span class="label"
                  >Costo di conversione:
                  <span class="info-icon-coin">
                    <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                    <span class="tooltip-coin">
                      I Coin saranno addebitati al Download del file
                    </span>
                  </span></span
                >
                <span class="value"
                  ><span class="costoincoin">{{
                    numeroClienti * creditiPerBilancio
                  }}</span
                  ><i class="fa-solid fa-coins"></i
                ></span>
              </div>
              <div
                v-if="creditiDisponibili < numeroClienti * creditiPerBilancio"
                class="crediti-insufficienti-msg"
              >
                <i class="fa-solid fa-circle-exclamation warning-icon"></i>
                Non hai Coin a sufficienza
              </div>

              <div
                v-if="creditiDisponibili < numeroClienti * creditiPerBilancio"
                class="acquista-coin-box"
                @click="showCoinPurchase = !showCoinPurchase"
              >
                <i class="fa-solid fa-cart-shopping"></i>
                <span>Acquista Coin</span>
              </div>
            </div>
            <!-- Modal overlay -->
            <div
              v-if="showCoinPurchase"
              class="modal-overlay"
              @click.self="showCoinPurchase = false"
            >
              <div class="modal-content">
                <button class="modal-close" @click="showCoinPurchase = false">
                  &times;
                </button>
                <CoinPurchase
                  :options="conversionOptions"
                  :useInternalModal="false"
                  :loading="isProcessing"
                  :messagePurchase="messagePurchase"
                  @coins-updated="fetchConversionCount"
                />
              </div>
            </div>
            <!--  <div class="gotostore">
            <p>Acquista altre conversioni</p>
            <i class="fa-solid fa-cart-shopping shopicon"></i>
          </div> -->
            <button
              class="btnfase2"
              @click="fase_2_bilancio"
              :disabled="
                calculating2 ||
                creditiDisponibili * creditiPerBilancio < numeroClienti
              "
              :title="
                creditiDisponibili < numeroClienti
                  ? 'Non hai abbastanza Coin disponibili'
                  : ''
              "
            >
              <span v-if="calculating2">
                <div class="spinner"></div>
                Elaborazione...
              </span>
              <span v-else>Prosegui conversione</span>
            </button>
          </div>
        </div>
        <!--------------------- FASE 2 ---------------------->
        <div v-if="fase2" class="fase2">
          <p class="numerofaseAttuale">Fase 2 di 3</p>

          <!-- Messaggio di risposta + navigazione sub-fasi -->
          <div
            :class="[
              'response-message',
              'bilancio-fase2-response',
              'conversion-table-surface',
              { 'dashboard-table-expanded': currentBilancioDashboardExpanded },
            ]"
          >
            <!-- TITOLI DIVERSI PER OGNI SUB-FASE -->
            <h3
              v-if="currentSubPhase === 'A'"
              class="cod-conto-individuati title-conv"
            >
              CODICI CONTO INDIVIDUATI
            </h3>

            <h3
              v-if="currentSubPhase === 'B'"
              class="cod-conto-individuati title-conv"
            >
              CLIENTI / FORNITORI INDIVIDUATI
            </h3>

            <div
              v-if="currentSubPhase === 'A' && showBilancioContoDashboard"
              class="codconto-table-dashboard bilancio-table-dashboard"
            >
              <div class="codconto-dashboard-tools">
                <button
                  type="button"
                  class="codconto-dashboard-button icon-only"
                  :disabled="!currentBilancioContoHasRows"
                  title="Espandi / Comprimi tabella"
                  @click="toggleCurrentBilancioContoExpansion"
                >
                  <i
                    :class="
                      currentBilancioContoExpanded
                        ? 'fa-solid fa-compress'
                        : 'fa-solid fa-expand'
                    "
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button"
                  :class="{ active: currentBilancioContoIsEditing }"
                  :disabled="!canUseCurrentBilancioContoEdit"
                  :title="currentBilancioContoEditTitle"
                  @click="toggleCurrentBilancioContoEditMode"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                  <span>{{ currentBilancioContoEditLabel }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-save"
                  :disabled="!currentBilancioContoHasChanges"
                  title="Salva modifiche"
                  @click="saveCurrentBilancioContoTable"
                >
                  <i class="fa-solid fa-floppy-disk"></i>
                  <span>Salva</span>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button icon-only"
                  :disabled="!currentBilancioContoCanUndo"
                  title="Annulla ultima modifica"
                  @click="undoCurrentBilancioContoTable"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-reset"
                  :disabled="!currentBilancioContoHasChanges"
                  title="Annulla tutte le modifiche"
                  @click="resetCurrentBilancioContoTable"
                >
                  <i class="fa-solid fa-xmark"></i>
                  <span>Annulla</span>
                </button>
              </div>
              <div class="codconto-dashboard-filters">
                <div
                  v-show="vettoreCodContoBA_PDC.length > 0"
                  class="codconto-code-view-controls"
                >
                  <button
                    type="button"
                    class="codconto-code-view-trigger codconto-dashboard-filter"
                    :class="{ active: bilancioContoViewDropdownOpen }"
                    @click.stop="toggleBilancioContoViewDropdown"
                  >
                    <i
                      :class="
                        vettorePBAVisible
                          ? 'fa-solid fa-book'
                          : 'fa-solid fa-list-check'
                      "
                      class="iconbtnPDC"
                    ></i>
                    <span>{{
                      vettorePBAVisible ? "Codici salvati" : "Nuovi codici"
                    }}</span>
                    <i
                      :class="
                        bilancioContoViewDropdownOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      class="toggle-icon"
                    ></i>
                  </button>
                  <div
                    v-if="bilancioContoViewDropdownOpen"
                    class="codconto-code-view-menu"
                  >
                    <button
                      type="button"
                      :class="{ active: !vettorePBAVisible }"
                      @click="selectBilancioContoView(false)"
                    >
                      <i class="fa-solid fa-list"></i>
                      <span>Nuovi codici</span>
                    </button>
                    <button
                      type="button"
                      :class="{ active: vettorePBAVisible }"
                      @click="selectBilancioContoView(true)"
                    >
                      <i class="fa-solid fa-book"></i>
                      <span>Codici salvati</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="currentSubPhase === 'B' && showBilancioCFDashboard"
              class="codconto-table-dashboard bilancio-table-dashboard"
            >
              <div class="codconto-dashboard-tools">
                <button
                  type="button"
                  class="codconto-dashboard-button icon-only"
                  :disabled="!currentBilancioCFHasRows"
                  title="Espandi / Comprimi tabella"
                  @click="toggleCurrentBilancioCFExpansion"
                >
                  <i
                    :class="
                      currentBilancioCFExpanded
                        ? 'fa-solid fa-compress'
                        : 'fa-solid fa-expand'
                    "
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button"
                  :class="{ active: currentBilancioCFIsEditing }"
                  :disabled="!canUseCurrentBilancioCFEdit"
                  :title="currentBilancioCFEditTitle"
                  @click="toggleCurrentBilancioCFEditMode"
                >
                  <i class="fa-regular fa-pen-to-square"></i>
                  <span>{{ currentBilancioCFEditLabel }}</span>
                  <i
                    v-if="vettoreCFVisible && !ha(user, 'modifica_anagrafica')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-save"
                  :disabled="!currentBilancioCFHasChanges"
                  title="Salva modifiche"
                  @click="saveCurrentBilancioCFTable"
                >
                  <i class="fa-solid fa-floppy-disk"></i>
                  <span>Salva</span>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button icon-only"
                  :disabled="!currentBilancioCFCanUndo"
                  title="Annulla ultima modifica"
                  @click="undoCurrentBilancioCFTable"
                >
                  <i class="fa-solid fa-rotate-left"></i>
                </button>
                <button
                  type="button"
                  class="codconto-dashboard-button codconto-dashboard-reset"
                  :disabled="!currentBilancioCFHasChanges"
                  title="Annulla tutte le modifiche"
                  @click="resetCurrentBilancioCFTable"
                >
                  <i class="fa-solid fa-xmark"></i>
                  <span>Annulla</span>
                </button>
              </div>
              <div class="codconto-dashboard-filters">
                <div
                  v-show="vettoreClientiFornitoriPDC.length > 0"
                  class="codconto-code-view-controls codconto-code-view-controls--wide"
                >
                  <button
                    type="button"
                    class="codconto-code-view-trigger codconto-dashboard-filter"
                    :class="{ active: bilancioCFViewDropdownOpen }"
                    @click.stop="toggleBilancioCFViewDropdown"
                  >
                    <i
                      :class="
                        vettoreCFVisible
                          ? 'fa-solid fa-address-book'
                          : 'fa-solid fa-user-plus'
                      "
                      class="iconbtnPDC"
                    ></i>
                    <span>{{
                      vettoreCFVisible ? "Clienti salvati" : "Nuovi clienti"
                    }}</span>
                    <i
                      :class="
                        bilancioCFViewDropdownOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      class="toggle-icon"
                    ></i>
                  </button>
                  <div
                    v-if="bilancioCFViewDropdownOpen"
                    class="codconto-code-view-menu"
                  >
                    <button
                      type="button"
                      :class="{ active: !vettoreCFVisible }"
                      @click="selectBilancioCFView(false)"
                    >
                      <i class="fa-solid fa-user-plus"></i>
                      <span>Nuovi clienti</span>
                    </button>
                    <button
                      type="button"
                      :class="{ active: vettoreCFVisible }"
                      @click="selectBilancioCFView(true)"
                    >
                      <i class="fa-solid fa-address-book"></i>
                      <span>Clienti salvati</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- SUB-FASE A: CODICI CONTO (come avevi tu) -->
            <div
              v-if="currentSubPhase === 'A'"
              class="bilancio-subphase-content"
            >
              <button
                v-show="vettoreCodContoBA_PDC.length > 0"
                class="btnPBAvisible legacy-bilancio-table-control"
                :class="{ active: vettorePBAVisible }"
                @click="vettorePBAVisible = !vettorePBAVisible"
              >
                <i class="fa-solid fa-book iconbtnPDC"></i>
                Codici Conto già salvati
                <i
                  :class="
                    vettorePBAVisible
                      ? 'fa-solid fa-chevron-down'
                      : 'fa-solid fa-chevron-right'
                  "
                  class="toggle-icon"
                ></i>
              </button>

              <!-- TABELLA ESPANDIBILE PDC (codici già salvati) -->
              <div
                class="divPBAtable"
                :class="{ 'table-hidden': !vettorePBAVisible }"
              >
                <div
                  v-show="vettoreCodContoBA_PDC.length > 0 && vettorePBAVisible"
                  class="cod_conto_table_divPBA"
                  :class="{ expanded: isTablePBAExpanded }"
                >
                  <table class="codcontotablePBA">
                    <thead>
                      <tr>
                        <th
                          class="headerIndici saved-library-header"
                          title="Già nel tuo Piano dei Conti"
                          aria-label="Già nel tuo Piano dei Conti"
                        >
                          <i
                            class="fa-solid fa-book saved-library-header-icon"
                            aria-hidden="true"
                          ></i>
                        </th>
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreCodContoBA_PDC"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumnsPBA"
                          :key="colIndex"
                          :class="[
                            {
                              'datev-column':
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto Datev Aziende' ||
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto Datev Liberi Prof.',
                              'italic-text':
                                isNessuno(
                                  vettoreCodContoBA_PDC[rowIndex][col]
                                ) ||
                                hasNessunaCorrelazione(
                                  vettoreCodContoBA_PDC[rowIndex][col]
                                ),
                              'cell-error': hasContoError(rowIndex, colIndex),
                            },
                            tableCellEditClasses(
                              'ba-pdc',
                              rowIndex,
                              col,
                              hasContoError(rowIndex, colIndex)
                            ),
                          ]"
                        >
                          <template v-if="isEditableColumnPBA(col)">
                            <input
                              v-model="vettoreCodContoBA_PDC[rowIndex][col]"
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    vettoreCodContoBA_PDC[rowIndex][col]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    vettoreCodContoBA_PDC[rowIndex][col]
                                  ),
                              }"
                              @input="
                                handleBilancioCellInput(
                                  'ba-pdc',
                                  rowIndex,
                                  colIndex,
                                  col,
                                  vettoreCodContoBA_PDC
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoBilancioTable(
                                  'ba-pdc',
                                  vettoreCodContoBA_PDC
                                )
                              "
                              @blur="
                                validateInput(
                                  rowIndex,
                                  colIndex,
                                  vettoreCodContoBA_PDC
                                )
                              "
                              @keydown.exact="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  col,
                                  colIndex,
                                  vettoreCodContoBA_PDC
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'ba-pdc',
                                  rowIndex,
                                  col,
                                  hasContoError(rowIndex, colIndex)
                                )
                              "
                            >
                              {{
                                vettoreCodContoBA_PDC[rowIndex][col] === "None"
                                  ? ""
                                  : vettoreCodContoBA_PDC[rowIndex][col]
                              }}
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pulsante Modifica (solo se visibili i salvati) -->
                <button
                  v-if="vettoreCodContoBA_PDC.length > 0 && vettorePBAVisible"
                  class="edit-buttonPDC legacy-bilancio-table-control"
                  :class="{
                    'active-editbuttonPDC':
                      isEditModePBA && hasTableChanges('ba-pdc'),
                    'editing-editbuttonPDC':
                      isEditModePBA && !hasTableChanges('ba-pdc'),
                  }"
                  @click="
                    isEditModePBA
                      ? saveBilancioTable('ba-pdc', vettoreCodContoBA_PDC)
                      : toggleEditModePBA()
                  "
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Modifica Codici conto già salvati - Disponibile da piano Plus'
                      : 'Modifica Codici conto già salvati'
                  "
                >
                  <i
                    :class="
                      isEditModePBA
                        ? 'fa-solid fa-floppy-disk edit-button-icon'
                        : 'fa-regular fa-pen-to-square edit-button-icon'
                    "
                  ></i>
                  <span class="edit-button-text">{{
                    isEditModePBA ? "Salva modifiche" : "Modifica"
                  }}</span>
                  <i
                    v-if="!ha(user, 'modifica_descrizione_nomi_conto')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button>
                <div
                  v-if="
                    vettoreCodContoBA_PDC.length > 0 &&
                    vettorePBAVisible &&
                    hasTableChanges('ba-pdc')
                  "
                  class="edit-session-actions legacy-bilancio-table-control"
                >
                  <button
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('ba-pdc')"
                    @click="undoBilancioTable('ba-pdc', vettoreCodContoBA_PDC)"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('ba-pdc')"
                    @click="
                      resetBilancioTable('ba-pdc', 'vettoreCodContoBA_PDC')
                    "
                  >
                    Annulla
                  </button>
                </div>
              </div>

              <!-- Quando toggle PDC chiuso: tabella codici individuati -->
              <div v-if="!vettorePBAVisible" class="bilancio-table-pane">
                <div
                  v-if="vettoreCodContoBilancioAnalitico.length > 0"
                  class="cod_conto_table_div"
                  :class="{ expanded: isTableExpanded }"
                >
                  <table class="codcontotablebilancio">
                    <thead>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Cod. Conto Datev Aziende' ||
                              header === 'Cod. Conto Datev Liberi Prof.',
                          }"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(
                          row, rowIndex
                        ) in vettoreCodContoBilancioAnalitico"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumns"
                          :key="colIndex"
                          :class="[
                            {
                              'datev-column':
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto Datev Aziende' ||
                                filteredHeaders[colIndex] ===
                                  'Cod. Conto Datev Liberi Prof.',
                              'italic-text': hasNessunaCorrelazione(
                                vettoreCodContoBilancioAnalitico[rowIndex][col]
                              ),
                              'cell-error': hasContoError(rowIndex, colIndex),
                            },
                            tableCellEditClasses(
                              'ba-main',
                              rowIndex,
                              col,
                              hasContoError(rowIndex, colIndex)
                            ),
                          ]"
                        >
                          <template v-if="isEditableColumn(col)">
                            <input
                              v-model="
                                vettoreCodContoBilancioAnalitico[rowIndex][col]
                              "
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    vettoreCodContoBilancioAnalitico[rowIndex][
                                      col
                                    ]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    vettoreCodContoBilancioAnalitico[rowIndex][
                                      col
                                    ]
                                  ),
                              }"
                              @input="
                                handleBilancioCellInput(
                                  'ba-main',
                                  rowIndex,
                                  colIndex,
                                  col,
                                  vettoreCodContoBilancioAnalitico
                                )
                              "
                              @keydown.ctrl.z.exact.prevent="
                                undoBilancioTable(
                                  'ba-main',
                                  vettoreCodContoBilancioAnalitico
                                )
                              "
                              @blur="
                                validateInput(
                                  rowIndex,
                                  colIndex,
                                  vettoreCodContoBilancioAnalitico
                                )
                              "
                              @keydown.exact="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  col,
                                  colIndex,
                                  vettoreCodContoBilancioAnalitico
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            <span
                              :class="
                                tableCellDisplayClasses(
                                  'ba-main',
                                  rowIndex,
                                  col,
                                  hasContoError(rowIndex, colIndex)
                                )
                              "
                            >
                              {{
                                vettoreCodContoBilancioAnalitico[rowIndex][
                                  col
                                ] === "None"
                                  ? ""
                                  : vettoreCodContoBilancioAnalitico[rowIndex][
                                      col
                                    ]
                              }}
                            </span>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Messaggio se tutto già presente -->
                <div
                  v-else-if="vettoreCodContoBA_PDC.length > 0"
                  class="success-container"
                >
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Tutti i Codici Conto individuati nel Bilancio Analitico sono
                    già presenti nel Piano dei Conti nella
                    <span class="scrittapiano">Libreria Clienti</span>
                  </p>
                </div>
                <div v-else class="converter-error-alert" role="alert">
                  <i
                    class="fa-solid fa-triangle-exclamation converter-error-alert__icon"
                    aria-hidden="true"
                  ></i>
                  <div class="converter-error-alert__content">
                    <strong>Nessun codice conto classificato</strong>
                    <span>
                      Il formato dei conti estratti non e' stato riconosciuto.
                      Interrompi la conversione e verifica il file.
                    </span>
                  </div>
                </div>
                <div
                  v-if="vettoreCodContoBilancioAnalitico.length > 0"
                  class="edit-session-actions"
                >
                  <button
                    class="edit-button"
                    :class="{
                      'legacy-bilancio-table-control': true,
                      'editing-editbutton': isEditModeBA,
                    }"
                    type="button"
                    @click="toggleEditModeBA"
                    :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                    title="Modifica Codici Conto individuati"
                  >
                    <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                    <span class="edit-button-text">{{
                      isEditModeBA ? "Chiudi" : "Personalizza"
                    }}</span>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-main')"
                    class="edit-button active-editbutton edit-session-save legacy-bilancio-table-control"
                    type="button"
                    title="Salva modifiche"
                    @click="
                      saveBilancioTable(
                        'ba-main',
                        vettoreCodContoBilancioAnalitico
                      )
                    "
                  >
                    <i class="fa-solid fa-floppy-disk edit-button-icon"></i>
                    <span class="edit-button-text">Salva modifiche</span>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-main')"
                    class="edit-session-utility legacy-bilancio-table-control"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('ba-main')"
                    @click="
                      undoBilancioTable(
                        'ba-main',
                        vettoreCodContoBilancioAnalitico
                      )
                    "
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-main')"
                    class="edit-session-utility reset-all legacy-bilancio-table-control"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('ba-main')"
                    @click="
                      resetBilancioTable(
                        'ba-main',
                        'vettoreCodContoBilancioAnalitico'
                      )
                    "
                  >
                    Annulla
                  </button>
                </div>
              </div>
            </div>

            <!-- SUB-FASE B: CLIENTI / FORNITORI INDIVIDUATI -->
            <div
              v-if="currentSubPhase === 'B'"
              class="bilancio-subphase-content"
            >
              <!-- Toggle per Clienti/Fornitori già salvati (PDC) -->
              <button
                v-show="vettoreClientiFornitoriPDC.length > 0"
                class="btnPBAvisible legacy-bilancio-table-control"
                :class="{ active: vettoreCFVisible }"
                @click="vettoreCFVisible = !vettoreCFVisible"
              >
                <i class="fa-solid fa-book iconbtnPDC"></i>
                Clienti / Fornitori già salvati
                <i
                  :class="
                    vettoreCFVisible
                      ? 'fa-solid fa-chevron-down'
                      : 'fa-solid fa-chevron-right'
                  "
                  class="toggle-icon"
                ></i>
              </button>

              <!-- TABELLA ESPANDIBILE PER PDC (clienti/fornitori salvati) -->
              <div
                class="divPBAtable"
                :class="{ 'table-hidden': !vettoreCFVisible }"
              >
                <div
                  v-show="
                    vettoreClientiFornitoriPDC.length > 0 && vettoreCFVisible
                  "
                  class="cod_conto_table_divPBA"
                  :class="{ expanded: isTableCFPDCExpanded }"
                >
                  <table class="codcontotableCF">
                    <!-- stessa classe base -->
                    <thead>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeadersCF"
                          :key="index"
                        >
                          {{ header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreClientiFornitoriPDC"
                        :key="rowIndex"
                      >
                        <!-- 1. Numero riga (non editabile) -->
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>

                        <!-- 2. Cod. Conto nel Bilancio Analitico (visualizzazione solo) -->
                        <td>{{ row[0] || "" }}</td>

                        <!-- 3. Denominazione CLIENTE/FORNITORE (visualizzazione solo) -->
                        <td>{{ row[1] || "" }}</td>

                        <!-- 4. DARE (visualizzazione solo, formattato) -->
                        <td class="text-right">{{ row[2] || "0,00" }}</td>

                        <!-- 5. AVERE (visualizzazione solo, formattato) -->
                        <td class="text-right">{{ row[3] || "0,00" }}</td>

                        <!-- 6. Cod. Conto - Software Contabile → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': hasContoSoftwareError(rowIndex) },
                            tableCellEditClasses(
                              'ba-cf-pdc',
                              rowIndex,
                              4,
                              hasContoSoftwareError(rowIndex)
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[4]"
                            :disabled="!isEditModeCFPDC"
                            @input="
                              handleBilancioCFInput(
                                'ba-cf-pdc',
                                rowIndex,
                                4,
                                vettoreClientiFornitoriPDC,
                                () =>
                                  validaContoSoftware(
                                    rowIndex,
                                    vettoreClientiFornitoriPDC
                                  )
                              )
                            "
                            @blur="
                              validaContoSoftware(
                                rowIndex,
                                vettoreClientiFornitoriPDC
                              )
                            "
                            @keydown.exact="blockLetters($event)"
                            @paste="blockPaste($event)"
                          />
                        </td>

                        <!-- 7. Codice Fiscale → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': errorsCF[rowIndex] },
                            tableCellEditClasses(
                              'ba-cf-pdc',
                              rowIndex,
                              5,
                              errorsCF[rowIndex]
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[5]"
                            :disabled="!isEditModeCFPDC"
                            @input="
                              trackTableCellChange(
                                'ba-cf-pdc',
                                rowIndex,
                                5,
                                row[5],
                                vettoreClientiFornitoriPDC,
                                'CLIENTI / FORNITORI GIÀ SALVATI'
                              )
                            "
                            @blur="validaCFPIVA($event, rowIndex)"
                            :class="{ 'is-invalid': errorsCF[rowIndex] }"
                            maxlength="16"
                          />
                        </td>

                        <!-- 8. Codice Anagrafica CLIENTE/FORNITORE → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': errorsAnag[rowIndex] },
                            tableCellEditClasses(
                              'ba-cf-pdc',
                              rowIndex,
                              6,
                              errorsAnag[rowIndex]
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[6]"
                            :disabled="!isEditModeCFPDC"
                            @input="
                              trackTableCellChange(
                                'ba-cf-pdc',
                                rowIndex,
                                6,
                                row[6],
                                vettoreClientiFornitoriPDC,
                                'CLIENTI / FORNITORI GIÀ SALVATI'
                              )
                            "
                            @blur="validaCodAnagrafica($event, rowIndex)"
                            :class="{ 'is-invalid': errorsAnag[rowIndex] }"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pulsante Modifica (opzionale, se permetti editing) -->
                <!-- <button
                  v-if="
                    vettoreClientiFornitoriPDC.length > 0 && vettoreCFVisible
                  "
                  class="edit-buttonPDC"
                  :class="{
                    'active-editbuttonPDC':
                      isEditModeCFPDC && hasTableChanges('ba-cf-pdc'),
                  }"
                  @click="toggleEditModeCFPDC"
                  :disabled="!ha(user, 'modifica_anagrafica')"
                  :title="
                    !ha(user, 'modifica_anagrafica')
                      ? 'Modifica Anagrafica - Disponibile da piano Plus'
                      : 'Modifica Anagrafica'
                  "
                >
                  <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                  <span class="edit-button-text">Modifica</span>
                  <i
                    v-if="!ha(user, 'modifica_anagrafica')"
                    class="fa-solid fa-lock lock-icon"
                  ></i>
                </button> -->
                <div
                  v-if="
                    vettoreClientiFornitoriPDC.length > 0 && vettoreCFVisible
                  "
                  class="edit-session-actions legacy-bilancio-table-control"
                >
                  <button
                    class="edit-buttonPDC"
                    :class="{
                      'active-editbuttonPDC':
                        isEditModeCFPDC && hasTableChanges('ba-cf-pdc'),
                      'editing-editbuttonPDC':
                        isEditModeCFPDC && !hasTableChanges('ba-cf-pdc'),
                    }"
                    type="button"
                    @click="
                      isEditModeCFPDC
                        ? saveBilancioTable(
                            'ba-cf-pdc',
                            vettoreClientiFornitoriPDC
                          )
                        : toggleEditModeCFPDC()
                    "
                    :disabled="!ha(user, 'modifica_anagrafica')"
                    title="Modifica Clienti / Fornitori gia salvati"
                  >
                    <i
                      :class="
                        isEditModeCFPDC
                          ? 'fa-solid fa-floppy-disk edit-button-icon'
                          : 'fa-regular fa-pen-to-square edit-button-icon'
                      "
                    ></i>
                    <span class="edit-button-text">{{
                      isEditModeCFPDC ? "Salva modifiche" : "Modifica"
                    }}</span>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-cf-pdc')"
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('ba-cf-pdc')"
                    @click="
                      undoBilancioTable('ba-cf-pdc', vettoreClientiFornitoriPDC)
                    "
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-cf-pdc')"
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('ba-cf-pdc')"
                    @click="
                      resetBilancioTable(
                        'ba-cf-pdc',
                        'vettoreClientiFornitoriPDC'
                      )
                    "
                  >
                    Annulla
                  </button>
                </div>
              </div>

              <!-- Quando toggle chiuso: tabella Clienti/Fornitori individuati -->
              <div v-if="!vettoreCFVisible" class="bilancio-table-pane">
                <div
                  v-if="vettoreClientiFornitori.length > 0"
                  class="cod_conto_table_div"
                  :class="{ expanded: isTableCFExpanded }"
                >
                  <table class="codcontotableCF">
                    <thead>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeadersCF"
                          :key="index"
                        >
                          {{ header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in vettoreClientiFornitori"
                        :key="rowIndex"
                      >
                        <!-- 1. Numero riga (non editabile) -->
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>

                        <!-- 2. Cod. Conto nel Bilancio Analitico (visualizzazione solo) -->
                        <td>{{ row[0] || "" }}</td>

                        <!-- 3. Denominazione CLIENTE/FORNITORE (visualizzazione solo) -->
                        <td>{{ row[1] || "" }}</td>

                        <!-- 4. DARE (visualizzazione solo, formattato) -->
                        <td class="text-right">{{ row[2] || "0,00" }}</td>

                        <!-- 5. AVERE (visualizzazione solo, formattato) -->
                        <td class="text-right">{{ row[3] || "0,00" }}</td>

                        <!-- 6. Cod. Conto - Software Contabile → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': hasContoSoftwareError(rowIndex) },
                            tableCellEditClasses(
                              'ba-cf',
                              rowIndex,
                              4,
                              hasContoSoftwareError(rowIndex)
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[4]"
                            :disabled="!isEditModeCF"
                            @input="
                              handleBilancioCFInput(
                                'ba-cf',
                                rowIndex,
                                4,
                                vettoreClientiFornitori,
                                () =>
                                  validaContoSoftware(
                                    rowIndex,
                                    vettoreClientiFornitori
                                  )
                              )
                            "
                            @blur="
                              validaContoSoftware(
                                rowIndex,
                                vettoreClientiFornitori
                              )
                            "
                            @keydown.exact="blockLetters($event)"
                            @paste="blockPaste($event)"
                          />
                        </td>

                        <!-- 7. Codice Fiscale → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': errorsCF[rowIndex] },
                            tableCellEditClasses(
                              'ba-cf',
                              rowIndex,
                              5,
                              errorsCF[rowIndex]
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[5]"
                            :disabled="!isEditModeCF"
                            @input="
                              trackTableCellChange(
                                'ba-cf',
                                rowIndex,
                                5,
                                row[5],
                                vettoreClientiFornitori,
                                'CLIENTI / FORNITORI INDIVIDUATI'
                              )
                            "
                            @blur="validaCFPIVA($event, rowIndex)"
                            :class="{ 'is-invalid': errorsCF[rowIndex] }"
                            maxlength="16"
                          />
                        </td>

                        <!-- 8. Codice Anagrafica CLIENTE/FORNITORE → EDITABILE -->
                        <td
                          :class="[
                            { 'cell-error': errorsAnag[rowIndex] },
                            tableCellEditClasses(
                              'ba-cf',
                              rowIndex,
                              6,
                              errorsAnag[rowIndex]
                            ),
                          ]"
                        >
                          <input
                            type="text"
                            class="editable-input"
                            v-model="row[6]"
                            :disabled="!isEditModeCF"
                            @input="
                              trackTableCellChange(
                                'ba-cf',
                                rowIndex,
                                6,
                                row[6],
                                vettoreClientiFornitori,
                                'CLIENTI / FORNITORI INDIVIDUATI'
                              )
                            "
                            @blur="validaCodAnagrafica($event, rowIndex)"
                            :class="{ 'is-invalid': errorsAnag[rowIndex] }"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Messaggio se tutto già presente -->
                <div v-else class="success-container">
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Tutti i Clienti / Fornitori individuati sono già presenti
                    nella
                    <span class="scrittapiano">Libreria Clienti/Fornitori</span>
                  </p>
                </div>
                <div
                  v-if="vettoreClientiFornitori.length > 0"
                  class="edit-session-actions legacy-bilancio-table-control"
                >
                  <button
                    class="edit-button"
                    :class="{ 'editing-editbutton': isEditModeCF }"
                    type="button"
                    @click="toggleEditModeCF"
                    title="Modifica Clienti / Fornitori individuati"
                  >
                    <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                    <span class="edit-button-text">{{
                      isEditModeCF ? "Chiudi modifica" : "Modifica"
                    }}</span>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-cf')"
                    class="edit-button active-editbutton edit-session-save"
                    type="button"
                    title="Salva modifiche"
                    @click="saveBilancioTable('ba-cf', vettoreClientiFornitori)"
                  >
                    <i class="fa-solid fa-floppy-disk edit-button-icon"></i>
                    <span class="edit-button-text">Salva modifiche</span>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-cf')"
                    class="edit-session-utility"
                    type="button"
                    title="Annulla ultima modifica"
                    :disabled="!hasTableUndo('ba-cf')"
                    @click="undoBilancioTable('ba-cf', vettoreClientiFornitori)"
                  >
                    <i class="fa-solid fa-rotate-left"></i>
                  </button>
                  <button
                    v-if="hasTableChanges('ba-cf')"
                    class="edit-session-utility reset-all"
                    type="button"
                    title="Annulla tutte le modifiche"
                    :disabled="!hasTableChanges('ba-cf')"
                    @click="
                      resetBilancioTable('ba-cf', 'vettoreClientiFornitori')
                    "
                  >
                    Annulla
                  </button>
                </div>
              </div>
            </div>

            <!-- NAVIGAZIONE SUB-FASE + PULSANTE FINALE -->
            <div class="subphase-navigation">
              <button
                v-show="!isFirstPhase"
                @click="prevSubPhase"
                class="prev-subphase-btn"
                title="Indietro"
              >
                <i class="fa-solid fa-arrow-left"></i>
              </button>

              <button
                v-show="!isLastPhase"
                @click="nextSubPhase"
                class="next-subphase-btn"
                title="Avanti"
              >
                <i class="fa-solid fa-arrow-right"></i>
              </button>

              <!-- Pulsante Converti SOLO sull'ultima sub-fase -->
              <button
                v-if="isLastPhase"
                class="btnfase2"
                @click="fase_3_bilancio"
                :disabled="calculating2"
              >
                <span v-if="calculating2">
                  <div class="spinner"></div>
                  Elaborazione...
                </span>
                <span v-else>Converti file</span>
              </button>
            </div>
          </div>
        </div>
        <!--------------------- FASE 3 ---------------------->
        <div v-if="fase3" class="fase3">
          <h3 class="anteprimafase3 title-conv">
            ANTEPRIMA DEL BILANCIO ANALITICO ELABORATO
          </h3>
          <p class="numerofaseAttuale">Fase 3 di 3</p>
          <!-- Messaggio di risposta -->
          <div
            class="response-message"
            v-if="mergedOverall && mergedOverall.length"
          >
            <div
              class="merged-table-container"
              :class="{ expanded: isTableExpanded }"
            >
              <table class="merged-table">
                <tbody>
                  <tr
                    v-for="(row, index) in mergedOverall"
                    :key="index"
                    :class="{
                      bilancino: isBilancino(row),
                      rigaCodDescrizione:
                        index > 0 && isBilancino(mergedOverall[index - 1]),
                    }"
                  >
                    <template v-if="isBilancino(row)">
                      <td :colspan="visibleCols" class="bilancino">
                        <span class="bilancino-name-text">{{ row[0] }}</span>
                      </td>
                    </template>

                    <template v-else>
                      <td v-for="colIndex in visibleCols" :key="colIndex">
                        {{ row[colIndex - 1] ?? "" }}
                      </td>
                    </template>
                  </tr>

                  <span class="expand-button-merged-span">
                    <i
                      @click="toggleTableExpansion"
                      :class="
                        isTableExpanded
                          ? 'fa-solid fa-compress expand-button-merged'
                          : 'fa-solid fa-expand expand-button-merged'
                      "
                      title="Espandi / Comprimi Tabella"
                    ></i>
                  </span>
                </tbody>
              </table>
            </div>
            <div class="scarica-file">
              <input
                type="checkbox"
                class="checkboxversionestesa"
                v-model="confermaConversione"
              />
              <label
                >Confermo di aver preso visione dei codici conto che vengono
                utilizzati per la conversione.</label
              >
              <span class="info-icon2">
                <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                <span class="tooltip2">
                  Mi assumo ogni responsabilità dell'utilizzo dei codici conto
                  da me selezionati.
                </span>
              </span>
              <p v-if="filePath">
                Il costo della conversione è di&nbsp;
                <span class="costoincoin">
                  {{ numeroClienti * creditiPerBilancio }}
                  <i class="fa-solid fa-coins"></i>
                </span>
                <span class="info-icon3">
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  <span class="tooltip3">
                    Il costo sarà addebitato solo al primo download. Potrai
                    scaricare il file più volte senza spese aggiuntive.
                  </span>
                </span>
              </p>
              <a
                v-if="filePath"
                href="#"
                @click="handleDownload"
                class="download"
                :class="{
                  'disabled-link': !confermaConversione,
                  'already-downloaded': hasDownloaded,
                }"
              >
                Download
              </a>
            </div>
          </div>
          <div class="skeleton-loader" v-if="!mergedOverall">
            <div class="skeleton skeleton-title"></div>
            <div class="skeleton skeleton-text"></div>
            <div class="skeleton skeleton-button"></div>
          </div>
        </div>
      </div>
      <PDFViewer
        v-if="showPDF"
        :visible="showPDF"
        :src="filePDF_URL"
        :title="fileTitle"
        @close="showPDF = false"
      />
      <ExcelViewer
        v-if="showExcelModal"
        :rows="ExcelRows"
        :visible="showExcelModal"
        :title="fileTitle"
        @close="showExcelModal = false"
      />
      <SimpleErrorModal
        :message="erroreModalMessaggio"
        :isVisible="erroreModalVisibile"
        @close="erroreModalVisibile = false"
      />
      <ConfirmActionModal
        :visible="showResetConfirmModal"
        :title="resetConfirmTitle"
        :eyebrow="resetConfirmEyebrow"
        :message="resetConfirmMessage"
        :confirm-label="resetConfirmConfirmLabel"
        :cancel-label="resetConfirmCancelLabel"
        :icon-class="resetConfirmIconClass"
        :confirm-icon-class="resetConfirmConfirmIconClass"
        :tone="
          ['table-edits', 'table-reset'].includes(resetConfirmContext)
            ? 'info'
            : 'danger'
        "
        @close="handleConfirmActionClose"
        @confirm="handleConfirmActionConfirm"
      />
      <PageLoadingOverlay
        :visible="isResettingConversion"
        :min-visible-ms="1000"
        :title="
          resetConfirmContext === 'leave'
            ? 'Uscita dal convertitore'
            : 'Reset del convertitore'
        "
        :message="
          resetConfirmContext === 'leave'
            ? 'Interruzione della conversione prima di cambiare pagina...'
            : 'Interruzione della conversione e pulizia dei dati in corso...'
        "
      />
      <ErrorMessageDisplay
        :errors="errorsData"
        :isVisible="showErrorModal"
        @close="showErrorModal = false"
        @fill-na="fillEmptyWithNA"
        @fill-no-corr="fillEmptyWithNoCorr"
        @proceed-warnings="proceedWithWarnings"
      />
    </div>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import {
  BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX,
  formatBilancioTeamSystemAccountCode,
} from "@/utils/bilancioAnaliticoCodes.js";
import { getUserSettings } from "@/utils/settings.js";
import { haFunzionalita as ha, isPiano } from "@/utils/plans.js";
import { puoModificareAnagraficaBilancio } from "@/utils/bilancioAnaliticoPermissions.js";
import { validFiscalCode } from "@/utils/fiscalCode.js";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import ErrorMessageDisplay from "../components/ErrorMessageDisplay.vue";
import PDFViewer from "@/components/PDFViewer.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import CoinPurchase from "@/components/CoinPurchase.vue";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";
import PageLoadingOverlay from "@/components/PageLoadingOverlay.vue";
import ProcessingWaitNotice from "@/components/ProcessingWaitNotice.vue";
import ConverterWelcomePanel from "@/components/ConverterWelcomePanel.vue";
import converterTableEditSession from "@/mixins/converterTableEditSession.js";
import AdminMsFiscalCodeGenerator from "@/components/AdminMsFiscalCodeGenerator.vue";
import {
  confirmClientRegistryAssociations,
  isClientRegistryConfirmation,
} from "@/utils/clientRegistryConfirmation.js";

export default {
  name: "ConvBilancioAnalitico",
  mixins: [converterTableEditSession],
  components: {
    SimpleErrorModal,
    ErrorMessageDisplay,
    PDFViewer,
    ExcelViewer,
    CoinPurchase,
    ConfirmActionModal,
    PageLoadingOverlay,
    ProcessingWaitNotice,
    ConverterWelcomePanel,
    AdminMsFiscalCodeGenerator,
  },
  data() {
    return {
      currentPlan: "",
      msg: "",
      userEmail: "", // Inizialmente vuoto, verrà impostato successivamente
      selectedFile: null,
      filePDF_URL: null,
      fileTitle: null,
      jobId: null,
      jobStatus: null,
      jobPollTimer: null,
      isCancelling: false,
      finalConversionInProgress: false,
      showPDF: false,
      showExcelModal: false,
      ExcelRows: [],
      fileType: "",
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      inputPcEditable: true, // Di default è abilitato
      excelPath: null,
      mergedOverall: null,
      hasDownloaded: false,
      hasOutputDownloadStarted: false,
      input_file_path: null,
      filePath: null,
      vettoreClienti: [],
      dateBilancioInputs: {},
      vettoreClienti_SEAC: [],
      vettoreCodContoBilancioAnalitico: [],
      vettoreCodContoBilancioAnaliticoModificato: [],
      vettoreCodContoBA_PDC: [],
      codContoDefault: "11/11/111",
      vettoreClientiFornitori: [],
      vettoreClientiFornitoriPDC: [],
      vettoreClientiFornitoriModificato: false,
      originalBA_PDC: null,
      originalClientiFornitoriPDC: null,
      vettorePBAVisible: false,
      bilancioContoViewDropdownOpen: false,
      bilancioCFViewDropdownOpen: false,
      isTablePBAExpanded: false,
      headers: [
        "Codice Conto del Bilancio", // Index 0
        "Descrizione del Codice Conto del Bilancio", // Index 1
        "DARE", // Index 2
        "AVERE", // Index 3
        "Cod. Conto", // Index 4
        "Cod. Conto 2", // Index 5
      ],
      headersCF: [
        "Cod. Conto nel Bilancio Analitico",
        "Denominazione CLIENTE/FORNITORE",
        "DARE",
        "AVERE",
        "Cod. Conto - Software Contabile",
        "Codice Fiscale",
        "Codice Anagrafica CLIENTE/FORNITORE",
      ],
      fase0: false,
      fase1: false,
      fase2: false,
      fase3: false,
      numeroClienti: 0,
      creditiPerBilancio: 0,
      calculating: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nella fase di Avvia conversione
      calculating2: false, // Variabile per controllare la visibilità del messaggio di calcolo in corso nelle fasi successsive
      input_PC: "",
      output_PC: "",
      output_PCfrontend: "",
      showInfoMenu: false, // Variabile per mostrare/nascondere il menu informazioni
      showDictionaryMenu: false, // Variabile per mostrare/nascondere il menu utente
      showAccountMenu: false, // Variabile per mostrare/nascondere il menu piano conti
      flag_PARTITARIO: false, // Aggiunto per gestire lo stato del toggle
      errorMessage: "",
      flag_output_std: false,
      flag_csv_import: false,
      flag_dettClientiFornitori: false,
      flag_CFPIVA: false,
      isShifted: false, // Nuova proprietà per controllare lo spostamento 1
      showResult: false, // Nuova proprietà per controllare lo spostamento 2
      isTableExpanded: false, // Controlla se la tabella è espansa
      creditiDisponibili: 0,
      conversioniEffettuate: 0,
      confermaConversione: false,
      showDelayedMessage: false,
      delayedMessageUpdated: false,
      delayTimer: null,
      updateTimer: null,
      erroreModalVisibile: false,
      erroreModalMessaggio: "",
      showResetConfirmModal: false,
      isResettingConversion: false,
      resetConfirmContext: "reset",
      resetConfirmTitle: "Interrompere la conversione?",
      resetConfirmEyebrow: "Reset convertitore",
      resetConfirmMessage:
        "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.",
      resetConfirmConfirmLabel: "Interrompi e resetta",
      resetConfirmCancelLabel: "Annulla",
      resetConfirmIconClass: "fa-solid fa-triangle-exclamation",
      resetConfirmConfirmIconClass: "fa-solid fa-arrows-rotate",
      pendingRouteLeaveNext: null,
      pendingRouteLeaveTarget: null,
      pendingTableReset: null,
      showErrorModal: false,
      errorsData: [],
      showCoinPurchase: false,
      restoringFile: false,
      isEditModeBA: false,
      isEditModePBA: false,
      naConfirmed: false,
      noCorrConfirmed: false,
      settings: {
        flag_saldoProspettiPaghe: true,
        flag_saldoF24: true,
        flag_accorpato: false,
        software_contabile: "default",
        flag_mostra_codice_ditta: true, // default prudente
        flag_dettClientiFornitori: false,
        flag_CFPIVA: false,
        // ← qui in futuro aggiungi altri flag senza toccare altro (aggiornare modelli db)
      },
      currentSubPhase: "A", // parte da codici conto
      vettoreCFVisible: false,
      isTableCFPDCExpanded: false,
      isTableCFExpanded: false,
      isEditModeCF: false,
      isEditModeCFPDC: false,
      errorsCF: {},
      errorsAnag: {},
      errorsConto: {},
      errorsContoSoftware: {},
    };
  },
  computed: {
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    errorAlertTitle() {
      const message = String(this.errorMessage || "").toLowerCase();
      if (message.includes("formato")) return "Formato file non valido";
      if (message.includes("software")) return "Selezione richiesta";
      if (message.includes("annullata")) return "Conversione annullata";
      return "Operazione non completata";
    },
    tableInteractionLocked() {
      return this.calculating2 || this.finalConversionInProgress;
    },
    showBilancioContoDashboard() {
      return (
        this.currentSubPhase === "A" &&
        ((Array.isArray(this.vettoreCodContoBilancioAnalitico) &&
          this.vettoreCodContoBilancioAnalitico.length > 0) ||
          (Array.isArray(this.vettoreCodContoBA_PDC) &&
            this.vettoreCodContoBA_PDC.length > 0))
      );
    },
    currentBilancioContoRows() {
      return this.vettorePBAVisible
        ? this.vettoreCodContoBA_PDC || []
        : this.vettoreCodContoBilancioAnalitico || [];
    },
    currentBilancioContoTableKey() {
      return this.vettorePBAVisible ? "ba-pdc" : "ba-main";
    },
    currentBilancioContoHasRows() {
      return this.currentBilancioContoRows.length > 0;
    },
    currentBilancioContoIsEditing() {
      return this.vettorePBAVisible ? this.isEditModePBA : this.isEditModeBA;
    },
    currentBilancioContoHasChanges() {
      return this.hasTableChanges(this.currentBilancioContoTableKey);
    },
    currentBilancioContoCanUndo() {
      return this.hasTableUndo(this.currentBilancioContoTableKey);
    },
    currentBilancioContoExpanded() {
      return this.vettorePBAVisible
        ? this.isTablePBAExpanded
        : this.isTableExpanded;
    },
    currentBilancioDashboardExpanded() {
      if (this.currentSubPhase === "A") {
        return this.currentBilancioContoExpanded;
      }
      if (this.currentSubPhase === "B") {
        return this.currentBilancioCFExpanded;
      }
      return false;
    },
    currentBilancioContoEditLabel() {
      if (this.currentBilancioContoIsEditing) return "Chiudi";
      return this.vettorePBAVisible ? "Modifica" : "Personalizza";
    },
    currentBilancioContoEditTitle() {
      if (!this.ha(this.user, "modifica_descrizione_nomi_conto")) {
        return this.vettorePBAVisible
          ? "Modifica Codici conto gia salvati - Disponibile da piano Plus"
          : "Personalizza Codici conto individuati - Disponibile da piano Plus";
      }
      return this.vettorePBAVisible
        ? "Modifica Codici conto gia salvati"
        : "Personalizza Codici conto individuati";
    },
    canUseCurrentBilancioContoEdit() {
      return (
        this.currentBilancioContoHasRows &&
        this.ha(this.user, "modifica_descrizione_nomi_conto")
      );
    },
    showBilancioCFDashboard() {
      return (
        this.currentSubPhase === "B" &&
        ((Array.isArray(this.vettoreClientiFornitori) &&
          this.vettoreClientiFornitori.length > 0) ||
          (Array.isArray(this.vettoreClientiFornitoriPDC) &&
            this.vettoreClientiFornitoriPDC.length > 0))
      );
    },
    currentBilancioCFRows() {
      return this.vettoreCFVisible
        ? this.vettoreClientiFornitoriPDC || []
        : this.vettoreClientiFornitori || [];
    },
    currentBilancioCFTableKey() {
      return this.vettoreCFVisible ? "ba-cf-pdc" : "ba-cf";
    },
    currentBilancioCFHasRows() {
      return this.currentBilancioCFRows.length > 0;
    },
    currentBilancioCFIsEditing() {
      return this.vettoreCFVisible ? this.isEditModeCFPDC : this.isEditModeCF;
    },
    currentBilancioCFHasChanges() {
      return this.hasTableChanges(this.currentBilancioCFTableKey);
    },
    currentBilancioCFCanUndo() {
      return this.hasTableUndo(this.currentBilancioCFTableKey);
    },
    currentBilancioCFExpanded() {
      return this.vettoreCFVisible
        ? this.isTableCFPDCExpanded
        : this.isTableCFExpanded;
    },
    currentBilancioCFEditLabel() {
      if (this.currentBilancioCFIsEditing) return "Chiudi";
      return "Modifica";
    },
    currentBilancioCFEditTitle() {
      if (!puoModificareAnagraficaBilancio(this.user, this.vettoreCFVisible)) {
        return "Modifica Clienti / Fornitori gia salvati - Disponibile da piano Plus";
      }
      return this.vettoreCFVisible
        ? "Modifica Clienti / Fornitori gia salvati"
        : "Modifica Clienti / Fornitori individuati";
    },
    canUseCurrentBilancioCFEdit() {
      return (
        this.currentBilancioCFHasRows &&
        puoModificareAnagraficaBilancio(this.user, this.vettoreCFVisible)
      );
    },
    validColumnsPBA() {
      return this.output_PC === "DATEV" ? [0, 1, 2, 3, 4, 5] : [0, 1, 2, 3, 4];
    },
    validColumns() {
      return this.output_PC === "DATEV" ? [0, 1, 2, 3, 4, 5] : [0, 1, 2, 3, 4];
    },
    filteredHeaders() {
      const commonHeaders = [
        "Codice Conto del Bilancio",
        "Descrizione del Codice Conto del Bilancio",
        "DARE",
        "AVERE",
      ];
      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return [...commonHeaders, "Cod. Conto TeamSystem"];
        case "DATEV":
          return [
            ...commonHeaders,
            "Cod. Conto Datev Aziende",
            "Cod. Conto Datev Liberi Prof.",
          ];
        case "ZUCCHETTI":
          return [...commonHeaders, "Cod. Conto Zucchetti"];
        case "SEAC":
          return [...commonHeaders, "Cod. Conto Seac"];
        case "SISTEMI":
          return [...commonHeaders, "Cod. Conto Sistemi"];
        default:
          return commonHeaders;
      }
    },
    filteredHeadersCF() {
      return this.headersCF.map((header) =>
        header.replace("Software Contabile", this.input_PC)
      );
    },
    hasPhaseB() {
      return (
        (Array.isArray(this.vettoreClientiFornitori) &&
          this.vettoreClientiFornitori.length > 0) ||
        (Array.isArray(this.vettoreClientiFornitoriPDC) &&
          this.vettoreClientiFornitoriPDC.length > 0)
      );
    },
    availablePhases() {
      const phases = ["A"];
      if (this.hasPhaseB) phases.push("B");
      return phases;
    },
    isFirstPhase() {
      return this.currentSubPhase === "A";
    },
    isLastPhase() {
      const phases = this.availablePhases;
      return this.currentSubPhase === phases[phases.length - 1];
    },
    visibleCols() {
      if (!this.mergedOverall.length) return 0;
      return this.mergedOverall[1].length - 2;
    },
  },
  watch: {
    user: {
      immediate: true,
      handler() {
        this.determineCurrentPlan();
      },
    },
    output_PC(value) {
      if (value && this.errorAlertTitle === "Selezione richiesta") {
        this.errorMessage = "";
      }
    },
  },
  methods: {
    ha,
    applyAdminMsFiscalCode({ index, fiscalCode }) {
      const client = this.vettoreClienti[index];
      if (Array.isArray(client)) this.$set(client, 4, fiscalCode);
    },
    normalizeCodContoValue(value) {
      return String(value ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    isCodContoDefault(value) {
      return (
        this.codContoDefault &&
        this.normalizeCodContoValue(value) ===
          this.normalizeCodContoValue(this.codContoDefault)
      );
    },
    applyCodContoDefaultFromResponse(data = {}) {
      if (data.codContoDefault) {
        this.codContoDefault = String(data.codContoDefault);
      }
    },
    preventLockedTableInteraction(event) {
      if (!this.tableInteractionLocked) return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const interactiveTarget = target.closest(
        [
          "input",
          "select",
          "textarea",
          "button",
          "label",
          "[contenteditable='true']",
          ".edit-button",
          ".btn-select",
          ".datev-config-toggle",
          ".datev-config-nav",
          ".datev-section-row",
        ].join(",")
      );

      if (!interactiveTarget) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof interactiveTarget.blur === "function") {
        interactiveTarget.blur();
      }
      if (target !== interactiveTarget && typeof target.blur === "function") {
        target.blur();
      }
    },
    toggleBilancioContoViewDropdown() {
      if (!this.vettoreCodContoBA_PDC.length) return;
      this.bilancioContoViewDropdownOpen = !this.bilancioContoViewDropdownOpen;
    },
    closeBilancioContoViewDropdown() {
      this.bilancioContoViewDropdownOpen = false;
    },
    selectBilancioContoView(showSaved) {
      this.vettorePBAVisible = showSaved;
      this.bilancioContoViewDropdownOpen = false;
    },
    toggleBilancioCFViewDropdown() {
      if (!this.vettoreClientiFornitoriPDC.length) return;
      this.bilancioCFViewDropdownOpen = !this.bilancioCFViewDropdownOpen;
    },
    closeBilancioCFViewDropdown() {
      this.bilancioCFViewDropdownOpen = false;
    },
    selectBilancioCFView(showSaved) {
      this.vettoreCFVisible = showSaved;
      this.bilancioCFViewDropdownOpen = false;
    },
    isPiano,
    determineCurrentPlan() {
      if (isPiano(this.user, "premium")) {
        this.currentPlan = "Premium";
      } else if (isPiano(this.user, "plus")) {
        this.currentPlan = "Plus";
      } else {
        this.currentPlan = "Base";
      }
    },
    getJobStorageKey() {
      return `conversion-job:bilancio:${this.userEmail || "session"}`;
    },
    isPersistableJobStatus(status) {
      return ["draft", "queued", "running", "cancel_requested"].includes(
        status
      );
    },
    isPollableJobStatus(status) {
      return ["queued", "running", "cancel_requested"].includes(status);
    },
    isConversionBusy() {
      return (
        (this.jobId &&
          !["completed", "failed", "cancelled"].includes(this.jobStatus)) ||
        this.calculating ||
        this.calculating2
      );
    },
    hasUndownloadedCompletedOutput() {
      return (
        this.fase3 && Boolean(this.filePath) && !this.hasOutputDownloadStarted
      );
    },
    shouldConfirmReset() {
      if (this.hasUndownloadedCompletedOutput()) {
        return true;
      }

      return (
        this.isConversionBusy() &&
        (this.calculating ||
          this.calculating2 ||
          this.fase1 ||
          this.fase2 ||
          this.fase3)
      );
    },
    openConversionInterruptModal(context, routeNext = null) {
      this.resetConfirmContext = context;
      this.pendingRouteLeaveNext = routeNext;

      if (this.hasUndownloadedCompletedOutput()) {
        this.resetConfirmTitle =
          context === "leave"
            ? "Uscire senza scaricare?"
            : "Resettare senza scaricare?";
        this.resetConfirmEyebrow = "Download non ancora eseguito";
        this.resetConfirmMessage =
          context === "leave"
            ? "La conversione è terminata, ma il file elaborato non è stato scaricato. Uscendo dalla pagina perderai questo risultato."
            : "La conversione è terminata, ma il file elaborato non è stato scaricato. Resettando il convertitore perderai questo risultato.";
        this.resetConfirmConfirmLabel =
          context === "leave"
            ? "Esci senza scaricare"
            : "Resetta senza scaricare";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass =
          context === "leave"
            ? "fa-solid fa-right-from-bracket"
            : "fa-solid fa-arrows-rotate";
      } else if (context === "leave") {
        this.resetConfirmTitle = "Uscire dalla pagina?";
        this.resetConfirmEyebrow = "Conversione in corso";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Uscendo dalla pagina interromperai l'elaborazione e i dati temporanei verranno puliti.";
        this.resetConfirmConfirmLabel = "Interrompi e Esci";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-right-from-bracket";
      } else {
        this.resetConfirmTitle = "Interrompere la conversione?";
        this.resetConfirmEyebrow = "Reset convertitore";
        this.resetConfirmMessage =
          "La conversione è ancora in corso. Interrompendo l'elaborazione la pagina verrà azzerata.";
        this.resetConfirmConfirmLabel = "Interrompi e resetta";
        this.resetConfirmCancelLabel = "Annulla";
        this.resetConfirmConfirmIconClass = "fa-solid fa-arrows-rotate";
      }

      this.resetConfirmIconClass = "fa-solid fa-triangle-exclamation";
      this.showResetConfirmModal = true;
    },
    cancelConversionInterrupt() {
      if (this.pendingRouteLeaveNext) {
        this.pendingRouteLeaveNext(false);
      }
      this.showResetConfirmModal = false;
      this.pendingRouteLeaveNext = null;
      this.pendingRouteLeaveTarget = null;
      this.resetConfirmContext = "reset";
    },
    shouldConfirmTableEditsBeforeConversion() {
      return (
        !this.pendingTableEditConversion &&
        this.pendingTableEditLabels.length > 0
      );
    },
    openTableEditsConversionConfirm() {
      const labels = this.pendingTableEditLabels.join(", ");
      this.resetConfirmContext = "table-edits";
      this.resetConfirmTitle = "Salvare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche non confermate";
      this.resetConfirmMessage = `Hai modifiche non salvate in: ${labels}. Vuoi salvarle e proseguire con la conversione?`;
      this.resetConfirmConfirmLabel = "Salva e converti";
      this.resetConfirmCancelLabel = "Annulla";
      this.resetConfirmIconClass = "fa-solid fa-circle-info";
      this.resetConfirmConfirmIconClass = "fa-solid fa-floppy-disk";
      this.showResetConfirmModal = true;
    },
    handleConfirmActionClose() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.resetConfirmContext = "reset";
        this.pendingTableReset = null;
        return;
      }
      this.cancelConversionInterrupt();
    },
    handleConfirmActionConfirm() {
      if (this.resetConfirmContext === "table-edits") {
        this.showResetConfirmModal = false;
        this.commitAllBilancioTableEdits();
        this.resetConfirmContext = "reset";
        this.pendingTableEditConversion = true;
        this.$nextTick(() => {
          this.fase_3_bilancio();
          this.pendingTableEditConversion = false;
        });
        return;
      }
      if (this.resetConfirmContext === "table-reset") {
        this.showResetConfirmModal = false;
        this.confirmResetBilancioTable();
        this.resetConfirmContext = "reset";
        return;
      }
      this.confirmResetDuringJob();
    },
    commitAllBilancioTableEdits() {
      this.commitTableEditSession(
        "ba-main",
        this.vettoreCodContoBilancioAnalitico
      );
      this.commitTableEditSession("ba-pdc", this.vettoreCodContoBA_PDC);
      this.commitTableEditSession("ba-cf", this.vettoreClientiFornitori);
      this.commitTableEditSession("ba-cf-pdc", this.vettoreClientiFornitoriPDC);
      this.isEditModeBA = false;
      this.isEditModePBA = false;
      this.isEditModeCF = false;
      this.isEditModeCFPDC = false;
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async waitForResetOverlayMinimum(startedAt) {
      const remaining = Math.max(1000 - (Date.now() - startedAt), 0);
      if (remaining > 0) {
        await this.wait(remaining);
      }
    },
    navigateHomeSafely() {
      if (this.shouldConfirmReset()) {
        this.pendingRouteLeaveTarget = "/home";
        this.openConversionInterruptModal("leave");
        return;
      }

      this.$router.push("/home");
    },
    persistJobState() {
      if (this.jobId && this.isPersistableJobStatus(this.jobStatus)) {
        const draftState =
          this.jobStatus === "draft"
            ? {
                input_PC: this.input_PC,
                output_PC: this.output_PC,
                input_file_path: this.input_file_path,
                vettoreClienti: this.vettoreClienti,
                dateBilancioInputs: this.dateBilancioInputs,
                numeroClienti: this.numeroClienti,
                creditiDisponibili: this.creditiDisponibili,
                flag_PARTITARIO: this.flag_PARTITARIO,
                flag_dettClientiFornitori: this.flag_dettClientiFornitori,
                flag_CFPIVA: this.flag_CFPIVA,
                vettoreCodContoBilancioAnalitico:
                  this.vettoreCodContoBilancioAnalitico,
                vettoreCodContoBA_PDC: this.vettoreCodContoBA_PDC,
                vettoreClientiFornitori: this.vettoreClientiFornitori,
                vettoreClientiFornitoriPDC: this.vettoreClientiFornitoriPDC,
                originalBA_PDC: this.originalBA_PDC,
                originalClientiFornitoriPDC: this.originalClientiFornitoriPDC,
                currentSubPhase: this.currentSubPhase,
                fase1: this.fase1,
                fase2: this.fase2,
              }
            : null;
        sessionStorage.setItem(
          this.getJobStorageKey(),
          JSON.stringify({
            jobId: this.jobId,
            status: this.jobStatus,
            finalConversionInProgress: this.finalConversionInProgress,
            draftState,
          })
        );
      } else {
        this.removePersistedJobState();
      }
    },
    removePersistedJobState() {
      sessionStorage.removeItem(this.getJobStorageKey());
    },
    async cleanupPurgeableJobs() {
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/cleanup_purgeable`, {
          tool: "bilancio_analitico",
          exclude_job_id: this.jobId,
        });
      } catch (error) {
        console.error("Errore durante il cleanup dei job bilancio:", error);
      }
    },
    async cleanupSpecificJob(jobId) {
      if (!jobId) return;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`);
      } catch (error) {
        if (![404, 409].includes(error.response?.status)) {
          console.error("Errore durante il cleanup del job:", error);
        }
      }
    },
    async waitForJobToBecomePurgeable(jobId, timeoutMs = 5000) {
      if (!jobId) return false;
      const deadline = Date.now() + timeoutMs;
      while (Date.now() < deadline) {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/conversion_jobs/${jobId}/status`
          );
          const status = response.data.job?.status;
          if (["draft", "completed", "failed", "cancelled"].includes(status)) {
            return true;
          }
        } catch (error) {
          if (error.response?.status === 404) {
            return true;
          }
        }
        await new Promise((resolve) => setTimeout(resolve, 400));
      }
      return false;
    },
    handleWindowBeforeUnload(event) {
      if (this.hasUndownloadedCompletedOutput()) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
      return undefined;
    },
    handleWindowPageHide() {
      if (!this.jobId) return;
      const jobId = this.jobId;
      if (this.jobStatus === "draft") {
        this.persistJobState();
        return;
      }
      if (this.isPollableJobStatus(this.jobStatus)) {
        fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`, {
          method: "POST",
          credentials: "include",
          keepalive: true,
        }).catch(() => {});
        return;
      }
      fetch(`${API_BASE_URL}/conversion_jobs/${jobId}/cleanup`, {
        method: "POST",
        credentials: "include",
        keepalive: true,
      }).catch(() => {});
    },
    clearJobState() {
      this.stopJobPolling();
      this.jobId = null;
      this.jobStatus = null;
      this.isCancelling = false;
      this.finalConversionInProgress = false;
      this.persistJobState();
    },
    stopJobPolling() {
      if (this.jobPollTimer) {
        clearInterval(this.jobPollTimer);
        this.jobPollTimer = null;
      }
    },
    startJobPolling() {
      this.stopJobPolling();
      if (!this.jobId) return;
      this.fetchJobStatus();
      this.jobPollTimer = setInterval(() => {
        this.fetchJobStatus(true);
      }, 2500);
    },
    async fetchJobStatus(silent = false) {
      if (!this.jobId) return;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/status`
        );
        this.applyJobState(response.data.job);
      } catch (error) {
        if (error.response?.status === 404) {
          this.calculating = false;
          this.calculating2 = false;
          this.stopJobPolling();
          this.clearJobState();
          return;
        }
        if (!silent) {
          console.error("Errore nel recupero dello stato job:", error);
        }
      }
    },
    applyJobState(job) {
      if (!job) return;
      this.jobId = job.job_id;
      this.jobStatus = job.status;
      this.persistJobState();

      if (job.status === "draft") {
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.stopJobPolling();
        return;
      }

      this.isShifted = true;
      this.showResult = true;
      this.fase0 = false;

      if (job.status === "completed") {
        this.removePersistedJobState();
        this.filePath = job.result_file_name;
        this.filesNames = job.result_files || [];
        this.downloadType = job.result_file_type;
        this.hasOutputDownloadStarted = false;
        this.fileName =
          job.result_file_type === "zip"
            ? "Bilanci Analitici.zip"
            : job.result_file_name;
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.fase1 = false;
        this.fase2 = false;
        this.fase3 = true;
        this.errorMessage = "";
        this.stopJobPolling();
        this.getMergedOverall();
        return;
      }

      if (job.status === "failed") {
        const failedJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = job.error_message || job.message || "Errore job";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(failedJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      if (job.status === "cancelled") {
        const cancelledJobId = job.job_id;
        this.removePersistedJobState();
        this.calculating = false;
        this.calculating2 = false;
        this.finalConversionInProgress = false;
        this.errorMessage = "Conversione annullata.";
        this.stopJobPolling();
        this.clearJobState();
        this.cleanupSpecificJob(cancelledJobId);
        this.cleanupPurgeableJobs();
        return;
      }

      this.calculating = false;
      this.calculating2 = true;
      this.fase1 = false;
      this.fase2 = true;
      this.fase3 = false;
    },
    async resumeStoredJob() {
      const raw = sessionStorage.getItem(this.getJobStorageKey());
      if (!raw) return;
      try {
        const parsed = JSON.parse(raw);
        if (!parsed?.jobId) return;
        this.jobId = parsed.jobId;
        this.jobStatus = parsed.status || null;
        this.finalConversionInProgress = Boolean(
          parsed.finalConversionInProgress
        );
        if (parsed.status === "draft" && parsed.draftState) {
          const state = parsed.draftState;
          this.input_PC = state.input_PC || null;
          this.output_PC = state.output_PC || null;
          this.input_file_path = state.input_file_path || null;
          this.vettoreClienti = state.vettoreClienti || [];
          this.dateBilancioInputs = state.dateBilancioInputs || {};
          this.numeroClienti = state.numeroClienti || 0;
          this.creditiDisponibili = state.creditiDisponibili || 0;
          this.flag_PARTITARIO = Boolean(state.flag_PARTITARIO);
          this.flag_dettClientiFornitori = Boolean(
            state.flag_dettClientiFornitori
          );
          this.flag_CFPIVA = Boolean(state.flag_CFPIVA);
          this.vettoreCodContoBilancioAnalitico =
            state.vettoreCodContoBilancioAnalitico || [];
          this.vettoreCodContoBA_PDC = state.vettoreCodContoBA_PDC || [];
          this.vettoreClientiFornitori = state.vettoreClientiFornitori || [];
          this.vettoreClientiFornitoriPDC =
            state.vettoreClientiFornitoriPDC || [];
          this.originalBA_PDC = state.originalBA_PDC || null;
          this.originalClientiFornitoriPDC =
            state.originalClientiFornitoriPDC || null;
          this.currentSubPhase = state.currentSubPhase || "A";
          this.fase0 = false;
          this.fase1 = Boolean(state.fase1);
          this.fase2 = Boolean(state.fase2);
          this.fase3 = false;
          this.isShifted = this.fase1 || this.fase2;
          this.showResult = this.isShifted;
          this.inputPcEditable = false;
        }
        await this.fetchJobStatus();
        if (this.jobId && this.isPollableJobStatus(this.jobStatus)) {
          this.startJobPolling();
        }
      } catch (error) {
        console.error("Errore nel ripristino del job:", error);
      }
    },
    async cancelActiveJob(resetAfter = true) {
      if (!this.jobId) {
        if (resetAfter) this.resetConversione();
        return;
      }
      const jobId = this.jobId;
      this.isCancelling = true;
      try {
        await axios.post(`${API_BASE_URL}/conversion_jobs/${jobId}/cancel`);
      } catch (error) {
        console.error("Errore nell'annullamento del job:", error);
      } finally {
        this.isCancelling = false;
      }
      await this.waitForJobToBecomePurgeable(jobId);
      await this.cleanupSpecificJob(jobId);
      await this.cleanupPurgeableJobs();
      this.stopJobPolling();
      this.clearJobState();
      if (resetAfter) {
        this.resetConversione();
      }
    },
    fase_1_bilancio() {
      if (this.selectedFile) {
        if (!this.output_PC) {
          this.errorMessage =
            "Devi selezionare il software contabile in cui convertire il file!";
          setTimeout(() => {
            this.errorMessage = "";
          }, 4000);
          return;
        }
        this.inputPcEditable = false;
        this.excelPath = null;
        this.calculating = true; // Mostra il messaggio di calcolo in corso
        this.errorMessage = "";
        const formData = new FormData();
        this.jobId = this.jobId || crypto.randomUUID();
        formData.append("pdfFile", this.selectedFile);
        formData.append("output_PC", this.output_PC);
        formData.append("job_id", this.jobId);

        this.startDelayMessageTimer();
        axios
          .post(`${API_BASE_URL}/fase_1_bilancio`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.clearDelayMessageTimer();
            this.applyCodContoDefaultFromResponse(res.data || {});
            this.jobId = res.data.job_id || this.jobId;
            this.input_PC = res.data.input_PC;
            this.input_file_path = res.data.input_file_path;
            this.vettoreClienti = res.data.vettoreClienti;
            this.initializeBilancioDateInputs(this.vettoreClienti);
            console.log("this.vettoreClienti è:");
            console.log(this.vettoreClienti);
            this.numeroClienti = res.data.numeroClienti;
            this.creditiDisponibili = res.data.crediti_disponibili;
            this.fase1 = true;
            this.jobStatus = "draft";
            this.persistJobState();
            return this.nextConversionStep(); // Mantiene il loading durante l'ingresso dei risultati
          })
          .catch((err) => {
            this.clearDelayMessageTimer();
            if (err.response?.data?.code === "JOB_ALREADY_RUNNING") {
              this.applyJobState(err.response.data.job);
              this.startJobPolling();
              return;
            }
            // Qui gestisci l'errore ricevuto dal backend
            if (err.response && err.response.data && err.response.data.error) {
              this.errorMessage = err.response.data.error; // Mostra il messaggio di errore ricevuto
            } else {
              this.errorMessage = "Errore nella richiesta al server.";
            }
            this.fase1 = false;
          })
          .then(() => {
            this.calculating = false; // Nasconde il messaggio di calcolo in corso
            if (this.errorMessage) {
              setTimeout(() => {
                this.errorMessage = null;
              }, 3500);
            }
          });
      }
    },
    fase_2_bilancio(registryConfirmed = false) {
      // Controllo per output_PC "DATEV": tutti i clienti devono avere una selezione
      if (this.output_PC === "DATEV") {
        const clientiIncompleti = this.vettoreClienti.some(
          (cliente) =>
            cliente[2] === 0 ||
            cliente[2] === "" ||
            cliente[2] === null ||
            cliente[2] === undefined
        );

        if (clientiIncompleti) {
          this.erroreModalMessaggio =
            "Specifica per ogni cliente se è un Azienda o un Libero Professionista prima di proseguire.";
          this.erroreModalVisibile = true;
          return;
        }
      }
      const clienti =
        this.input_PC === "SEAC"
          ? this.vettoreClienti_SEAC
          : this.vettoreClienti;

      if (!this.normalizeBilancioClientTitles()) {
        this.erroreModalMessaggio =
          "Inserisci una data valida per tutti i clienti nel formato GG/MM/AAAA.";
        this.erroreModalVisibile = true;
        return;
      }

      let ciSonoMancanti = false;
      let ciSonoNonValidi = false;

      clienti.forEach((cliente) => {
        const codDitta = (cliente[0] || "").trim();
        const codiceFiscale = (cliente[4] || "").trim();

        // Controllo CF → sempre obbligatorio
        if (!codiceFiscale) {
          ciSonoMancanti = true;
        }

        if (codiceFiscale && !this.isValidCodiceFiscale(codiceFiscale)) {
          ciSonoNonValidi = true;
        }

        // Controllo codice ditta → obbligatorio SOLO se il flag è true
        if (this.settings.flag_mostra_codice_ditta && !codDitta) {
          ciSonoMancanti = true;
        }
      });

      // Errore sui CF non validi (indipendente dal flag)
      if (ciSonoNonValidi) {
        this.erroreModalMessaggio =
          "Alcuni Codici fiscali non sono validi.\n\n";
        this.erroreModalVisibile = true;
        return;
      }

      // Errore sui campi mancanti
      if (ciSonoMancanti) {
        if (this.settings.flag_mostra_codice_ditta) {
          // Caso classico: entrambi obbligatori
          this.erroreModalMessaggio =
            "Inserisci Codice ditta e Codice fiscale per tutti i clienti.";
        } else {
          // Solo CF obbligatorio
          this.erroreModalMessaggio =
            "Inserisci il Codice fiscale per tutti i clienti.";
        }

        this.erroreModalVisibile = true;
        return;
      }
      this.calculating2 = true;
      // Costruisci l'oggetto da inviare al backend
      const payload = {
        job_id: this.jobId,
        input_PC: this.input_PC,
        input_file_path: this.input_file_path,
        output_PC: this.output_PC,
        flag_PARTITARIO: this.flag_PARTITARIO,
        vettoreClienti: this.vettoreClienti,
        vettoreClienti_SEAC: this.vettoreClienti_SEAC,
        flag_dettClientiFornitori: this.flag_dettClientiFornitori,
        confirm_registry_associations: registryConfirmed,
      };
      this.startDelayMessageTimer();
      // Effettua la richiesta HTTP al backend
      axios
        .post(`${API_BASE_URL}/fase_2_bilancio`, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("debug1");
          this.clearDelayMessageTimer();
          this.applyCodContoDefaultFromResponse(response.data || {});
          this.jobId = response.data.job_id || this.jobId;
          this.currentSubPhase = "A";
          this.vettorePBAVisible = false;
          this.vettoreCFVisible = false;
          this.isEditModePBA = false;
          this.isEditModeCFPDC = false;
          this.isTablePBAExpanded = false;
          this.isTableCFExpanded = false;
          this.isTableCFPDCExpanded = false;
          // === 1. vettoreCodContoBilancioAnalitico (tuo codice originale) ===
          const cleanedData =
            response.data.vettoreCodContoBilancioAnalitico.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) => {
                    if (
                      ([1, 2, 3, 4, 5, 6].includes(index) &&
                        (cell == null || cell === "None")) ||
                      this.isCodContoDefault(cell)
                    ) {
                      return null;
                    }
                    return cell;
                  })
                : row
            );
          this.vettoreCodContoBilancioAnalitico = cleanedData;
          console.log("this.vettoreCodContoBilancioAnalitico");
          console.log(this.vettoreCodContoBilancioAnalitico);

          // === 2. vettoreCodContoBA_PDC + DEEP COPY (AGGIUNTO) ===
          const cleanedData2 = response.data.vettoreCodContoBA_PDC.map((row) =>
            Array.isArray(row)
              ? row.map((cell, index) => {
                  if (
                    ([1, 2, 3, 4, 5, 6].includes(index) &&
                      (cell == null || cell === "None")) ||
                    this.isCodContoDefault(cell)
                  ) {
                    return null;
                  }
                  return cell;
                })
              : row
          );
          this.vettoreCodContoBA_PDC = cleanedData2;
          console.log("this.vettoreCodContoBA_PDC");
          console.log(this.vettoreCodContoBA_PDC);

          // DEEP COPY QUI!
          this.originalBA_PDC = JSON.parse(
            JSON.stringify(this.vettoreCodContoBA_PDC)
          );
          console.log("this.vettoreCodContoBilancioAnalitico:");
          console.log(this.vettoreCodContoBilancioAnalitico);

          this.vettoreClientiFornitori =
            response.data.vettoreClientiFornitori || [];
          this.vettoreClientiFornitoriPDC =
            response.data.vettoreClientiFornitoriPDC || [];

          this.originalClientiFornitoriPDC = JSON.parse(
            JSON.stringify(this.vettoreClientiFornitoriPDC)
          );

          console.log("Fornitori ricevuti:", this.vettoreClientiFornitori);
          console.log(
            "Fornitori PDC ricevuti:",
            this.vettoreClientiFornitoriPDC
          );
          this.primeTableEditSession(
            "ba-main",
            "CODICI CONTO INDIVIDUATI",
            this.vettoreCodContoBilancioAnalitico,
            true
          );
          this.primeTableEditSession(
            "ba-pdc",
            "CODICI CONTO GIÀ SALVATI",
            this.vettoreCodContoBA_PDC,
            true
          );
          this.primeTableEditSession(
            "ba-cf",
            "CLIENTI / FORNITORI INDIVIDUATI",
            this.vettoreClientiFornitori,
            true
          );
          this.primeTableEditSession(
            "ba-cf-pdc",
            "CLIENTI / FORNITORI GIÀ SALVATI",
            this.vettoreClientiFornitoriPDC,
            true
          );
          // Salva una copia profonda dei dati filtrati
          this.fase1 = false;
          this.fase2 = true;
          this.calculating2 = false;
          this.jobStatus = "draft";
          this.persistJobState();
        })
        .catch((error) => {
          this.clearDelayMessageTimer();
          if (isClientRegistryConfirmation(error)) {
            this.calculating2 = false;
            confirmClientRegistryAssociations(error, () =>
              this.fase_2_bilancio(true)
            );
            return;
          }
          console.error("Errore nella conversione:", error);
          this.erroreModalMessaggio =
            error.response?.data?.error ||
            "Errore durante la conversione. Controlla la console o riprova.";
          this.erroreModalVisibile = true;
          this.calculating2 = false;
        });
    },

    fase_3_bilancio() {
      if (this.shouldConfirmTableEditsBeforeConversion()) {
        this.openTableEditsConversionConfirm();
        return;
      }
      if (!this.validateAllInputs()) {
        return;
      }

      this.finalConversionInProgress = true;
      this.calculating2 = true;

      // ── CODICI CONTO ─────────────────────────────────────────────────
      const validColumns = this.getValidColumns();

      let finalVector = this.vettoreCodContoBilancioAnalitico.map((row) =>
        row.map((cell, index) => (validColumns.includes(index) ? cell : null))
      );

      if (this.isBAPDCModified() && this.vettoreCodContoBA_PDC.length > 0) {
        const pdcValidCols = this.validColumnsBA_PDC || validColumns;
        const pdcRows = this.vettoreCodContoBA_PDC.map((row) =>
          row.map((cell, index) => (pdcValidCols.includes(index) ? cell : null))
        );
        finalVector = [...finalVector, ...pdcRows];
        console.log(
          "BA_PDC MODIFICATO → aggiunte",
          pdcRows.length,
          "righe codici conto"
        );
      } else {
        console.log("BA_PDC NON MODIFICATO → codici conto PDC ignorati");
      }

      finalVector = finalVector.map((arr) => [arr[1], arr[0], ...arr.slice(4)]);

      console.log("VETTORE FINALE CODICI CONTO (unificato):", finalVector);

      // ── CLIENTI / FORNITORI ──────────────────────────────────────────
      let finalClientiFornitori = [...this.vettoreClientiFornitori];

      if (
        this.isClientiFornitoriPDCModified() &&
        this.vettoreClientiFornitoriPDC.length > 0
      ) {
        finalClientiFornitori = [
          ...finalClientiFornitori,
          ...this.vettoreClientiFornitoriPDC,
        ];
        console.log(
          "Clienti/Fornitori PDC MODIFICATI → aggiunte",
          this.vettoreClientiFornitoriPDC.length,
          "righe"
        );
      } else {
        console.log("Clienti/Fornitori PDC NON MODIFICATI → ignorati");
      }
      console.log(
        "VETTORE FINALE CLIENTI/FORNITORI (unificato e ridotto a 5 colonne):",
        finalClientiFornitori
      );

      // ── PAYLOAD ──────────────────────────────────────────────────────
      this.flag_output_std = !this.flag_csv_import;

      const payload = {
        job_id: this.jobId,
        input_PC: this.input_PC,
        output_PC: this.output_PC,
        vettoreClienti: this.vettoreClienti,
        flag_output_std: this.flag_output_std,
        vettoreCodContoBilancioAnalitico: finalVector,
        vettoreClientiFornitori: finalClientiFornitori, // ← unificato e corretto
        flag_dettClientiFornitori: this.flag_dettClientiFornitori,
        flag_CFPIVA: this.flag_CFPIVA,
      };

      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/fase_3_bilancio`, payload, {
          headers: { "Content-Type": "application/json" },
        })
        .then((res) => {
          this.clearDelayMessageTimer();
          this.naConfirmed = false;

          if (res.data.success && res.data.job) {
            this.hasDownloaded = false;
            this.applyJobState(res.data.job);
            this.startJobPolling();
          } else {
            this.errorMessage = res.data.error || "Errore generico dal backend";
            this.calculating2 = false;
            this.finalConversionInProgress = false;
          }
        })
        .catch((err) => {
          this.clearDelayMessageTimer();
          this.errorMessage = "Errore di comunicazione col server";
          this.calculating2 = false;
          this.finalConversionInProgress = false;
          console.error("Errore nella richiesta Axios:", err);
        });
    },
    nextConversionStep() {
      this.isShifted = true;
      this.showResult = true;
      return this.$nextTick().then(
        () =>
          new Promise((resolve) => {
            setTimeout(resolve, 720);
          })
      );
    },
    async refreshConversione() {
      if (this.shouldConfirmReset()) {
        this.openConversionInterruptModal("reset");
        return;
      }
      if (this.jobId) {
        if (this.isPollableJobStatus(this.jobStatus)) {
          await this.cancelActiveJob(false);
        } else {
          await this.cleanupSpecificJob(this.jobId);
          await this.cleanupPurgeableJobs();
        }
      }
      this.resetConversione();
    },
    async confirmResetDuringJob() {
      const context = this.resetConfirmContext;
      const routeNext = this.pendingRouteLeaveNext;
      const routeTarget = this.pendingRouteLeaveTarget;
      const isCompletedOutputPending = this.hasUndownloadedCompletedOutput();
      this.showResetConfirmModal = false;
      this.isResettingConversion = true;
      const resetStartedAt = Date.now();
      try {
        if (isCompletedOutputPending) {
          if (this.jobId) {
            await this.cleanupSpecificJob(this.jobId);
            await this.cleanupPurgeableJobs();
          }
          this.clearJobState();
        } else {
          await this.cancelActiveJob(false);
        }
        await this.waitForResetOverlayMinimum(resetStartedAt);
        if (context === "leave" && routeTarget) {
          this.$router.push(routeTarget);
        } else if (context === "leave" && routeNext) {
          routeNext();
        } else {
          this.resetConversione();
          await this.$nextTick();
          await this.wait(40);
        }
      } finally {
        this.isResettingConversion = false;
        this.pendingRouteLeaveNext = null;
        this.pendingRouteLeaveTarget = null;
        this.resetConfirmContext = "reset";
      }
    },
    resetConversione() {
      setTimeout(() => {
        this.isShifted = false; // Rimuove il "shift" per tornare alla posizione iniziale
      }, 10); // Il delay di 10ms è per permettere alla transizione di essere applicata
      // Resetta il file input
      if (this.filePDF_URL) {
        URL.revokeObjectURL(this.filePDF_URL);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      this.showResult = false;
      this.fase0 = true;
      this.fase1 = false;
      this.fase2 = false;
      this.fase3 = false;
      this.selectedFile = null;
      this.filePDF_URL = null;
      this.fileTitle = null;
      this.ExcelRows = [];
      this.fileType = "";
      this.excelPath = null;
      this.input_file_path = null;
      this.mergedOverall = null;
      this.filePath = null;
      this.showPDF = false;
      this.showExcelModal = false;
      this.input_PC = "";
      this.errorMessage = "";
      this.flag_csv_import = false;
      this.flag_dettClientiFornitori = false;
      this.flag_output_std = false;
      this.flag_PARTITARIO = false;
      this.vettoreClienti = [];
      this.dateBilancioInputs = {};
      this.vettoreCodContoBilancioAnalitico = [];
      this.vettoreCodContoBilancioAnaliticoModificato = [];
      this.vettoreCodContoBA_PDC = [];
      this.originalBA_PDC = null;
      this.vettorePBAVisible = false;
      this.vettoreClientiFornitoriPDC = [];
      this.vettoreCFVisible = false;
      this.vettoreClientiFornitori = [];
      this.vettoreClientiFornitoriPDC = [];
      this.vettoreClientiFornitoriModificato = false;
      this.originalClientiFornitoriPDC = null;
      this.currentSubPhase = "A";
      this.confermaConversione = false;
      this.hasDownloaded = false;
      this.hasOutputDownloadStarted = false;
      this.isTableExpanded = false;
      this.isTablePBAExpanded = false;
      this.isTableCFExpanded = false;
      this.isTableCFPDCExpanded = false;
      this.isEditModeBA = false;
      this.isEditModePBA = false;
      this.isEditModeCF = false;
      this.isEditModeCFPDC = false;
      this.clearAllTableEditSessions();
      this.errorsData = [];
      this.showErrorModal = false;
      this.erroreModalVisibile = false;
      this.erroreModalMessaggio = "";
      this.errorsCF = {};
      this.errorsAnag = {};
      this.errorsConto = {};
      this.errorsContoSoftware = {};
      this.naConfirmed = false;
      this.noCorrConfirmed = false;
      this.showCoinPurchase = false;
      this.clearDelayMessageTimer();
      this.clearJobState();
      this.loadSettings();
    },
    async fetchClients() {
      try {
        const response = await axios.get(`${API_BASE_URL}/vettore_datev`);
        this.vettoreClienti = response.data;
      } catch (error) {
        console.error("Errore nel recupero dei clienti:", error);
      }
    },
    getMergedOverall() {
      if (!this.jobId) return;
      axios
        .get(`${API_BASE_URL}/merged_overall`, {
          params: { job_id: this.jobId },
          responseType: "arraybuffer", // Importante per dati binari
        })
        .then((response) => {
          const data = new Uint8Array(response.data); // Converte i dati in array di byte
          const workbook = XLSX.read(data, { type: "array" }); // Legge il file Excel
          const firstSheetName = workbook.SheetNames[0]; // Prende il nome del primo foglio
          const worksheet = workbook.Sheets[firstSheetName];

          // Converte i dati del foglio in JSON e li salva in mergedOverall
          this.mergedOverall = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });
          // Normalizza le righe per avere lo stesso numero di colonne
          const maxColumns = this.mergedOverall[0].length;
          this.mergedOverall.forEach((row) => {
            while (row.length < maxColumns) {
              row.push(""); // Aggiunge celle vuote se mancano
            }
          });
          this.mergedOverall[0].push(""); // Aggiunge un header vuoto per la colonna del cestino
          console.log("this.mergedOverall è:");
          console.log(this.mergedOverall);
        })
        .catch((error) => {
          console.error("Errore nel caricamento di Merged Overall:", error);
        });
    },
    isBilancino(row) {
      return (
        row[0] &&
        row.slice(1).every((cell) => cell === "" || cell === undefined)
      );
    },
    handleFileChange(event) {
      console.log(
        "Change event triggered - files length:",
        event.target.files.length,
        "restoringFile:",
        this.restoringFile
      );

      // If we're restoring, skip processing to avoid infinite loop
      if (this.restoringFile) {
        this.restoringFile = false;
        console.log(
          "Restoration complete - selectedFile:",
          this.selectedFile?.name,
          "fileTitle:",
          this.fileTitle,
          "input files:",
          this.$refs.fileInput.files[0]?.name
        );
        // Check if files were cleared unexpectedly and reapply restoration
        if (this.selectedFile && !this.$refs.fileInput.files.length) {
          console.log(
            "Files cleared unexpectedly, reapplying restoration for:",
            this.selectedFile.name
          );
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
            console.log(
              "Re-restoration attempted - input files:",
              this.$refs.fileInput.files[0]?.name
            );
          });
        }
        return;
      }

      const newFile = event.target.files[0];

      // Detect cancel: files.length === 0 (browser cleared it)
      if (!newFile) {
        if (this.selectedFile) {
          console.log(
            "Cancel detected - restoring file:",
            this.selectedFile.name
          );
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.selectedFile);
            this.$refs.fileInput.files = dataTransfer.files;
            this.restoringFile = true; // Set flag for potential change event
            this.fileTitle = this.selectedFile.name; // Ensure fileTitle is in sync
            console.log(
              "Restoration attempted - input files:",
              this.$refs.fileInput.files[0]?.name
            );
          });
        } else {
          this.fileTitle = "Nessun file selezionato";
          console.log("No previous file to restore");
        }
        return;
      }
      const previousFile = this.selectedFile;
      const isSameFile =
        previousFile &&
        previousFile.name === newFile.name &&
        previousFile.lastModified === newFile.lastModified;

      if (isSameFile) {
        this.inputPcEditable = false;
        this.fileTitle = previousFile.name;
        console.log("Same file selected, no changes");
        return;
      }

      if (previousFile) {
        this.resetConversione();
        if (this.$refs.fileInput) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(newFile);
          this.$refs.fileInput.files = dataTransfer.files;
        }
      }

      this.errorMessage = "";

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Set fileType per distinguere CSV da Excel
      if (estensione === "csv") {
        this.fileType = "csv";
      } else if (["xls", "xlsx", "xlsm"].includes(estensione)) {
        this.fileType = "excel";
      } else {
        this.fileType = "";
      }

      // Se il file è PDF, genera URL per visualizzazione
      if (newFile.type === "application/pdf") {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = URL.createObjectURL(newFile);
      } else {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = null;
      }

      // Gestione primo caricamento o file diverso
      if (!this.selectedFile) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.fileTitle = this.selectedFile.name;
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("First file selected:", this.selectedFile.name);
        return;
      }

      // Controlla se è cambiato il file selezionato
      if (
        this.selectedFile.name !== newFile.name ||
        this.selectedFile.lastModified !== newFile.lastModified
      ) {
        this.selectedFile = newFile;
        this.inputPcEditable = true;
        this.resetConversione();
        this.leggiFileExcelOCsv(newFile, estensione);
        console.log("New file selected:", this.selectedFile.name);
      } else {
        this.inputPcEditable = false;
        console.log("Same file selected, no changes");
      }

      this.fileTitle = this.selectedFile.name;
      console.log(
        "After handleFileChange - selectedFile:",
        this.selectedFile?.name,
        "fileTitle:",
        this.fileTitle,
        "input files:",
        this.$refs.fileInput.files[0]?.name
      );
    },

    leggiFileExcelOCsv(file, estensione) {
      if (estensione === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const testoCsv = e.target.result;
          this.ExcelRows = testoCsv.split("\n").map((line) => line.split(","));
        };
        reader.readAsText(file);
      } else if (estensione === "xls" || estensione === "xlsx") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.ExcelRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.ExcelRows = [];
        this.fileType = "";
      }
    },
    openPDFPreview() {
      this.showPDF = true;
    },
    cleanbackend() {},
    getValidColumns() {
      // Mappa delle colonne da escludere in base a output_PC
      const excludedColumnsMap = {
        TEAMSYSTEM: [5], // Escludi Datev e Zucchetti
        DATEV: [9], // Escludi Teamsystem e Zucchetti
        ZUCCHETTI: [5], // Escludi Teamsystem e Datev
        SEAC: [5],
        SISTEMI: [5],
      };

      // Ottieni gli indici da escludere per il valore attuale di output_PC
      const excludedColumns = excludedColumnsMap[this.output_PC] || [];

      // Restituisci solo gli indici che non sono da escludere
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excludedColumns.includes(index));
    },
    isEditableColumnPBA(originalIndex) {
      if (!this.isEditModePBA) {
        return;
      }
      if (this.input_PC === "SEAC" && originalIndex === 0) {
        return true;
      }
      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 4;
        case "DATEV":
          return originalIndex === 4 || originalIndex === 5;
        case "ZUCCHETTI":
          return originalIndex === 4;
        case "SEAC":
          return originalIndex === 4;
        case "SISTEMI":
          return originalIndex === 4;
        default:
          return false;
      }
    },
    isEditableColumn(originalIndex) {
      if (this.input_PC === "SEAC" && originalIndex === 0) {
        return true;
      }
      switch (this.output_PC) {
        case "TEAMSYSTEM":
          return originalIndex === 4;
        case "DATEV":
          return originalIndex === 4 || originalIndex === 5;
        case "ZUCCHETTI":
          return originalIndex === 4;
        case "SEAC":
          return originalIndex === 4;
        case "SISTEMI":
          return originalIndex === 4;
        default:
          return false;
      }
    },
    toggleEditModePBA() {
      this.toggleTableEditSession(
        "ba-pdc",
        "CODICI CONTO GIÀ SALVATI",
        this.vettoreCodContoBA_PDC
      );
      this.isEditModePBA = this.isTableEditing("ba-pdc");
    },
    toggleEditModeBA() {
      this.toggleTableEditSession(
        "ba-main",
        "CODICI CONTO INDIVIDUATI",
        this.vettoreCodContoBilancioAnalitico
      );
      this.isEditModeBA = this.isTableEditing("ba-main");
    },
    toggleCurrentBilancioContoExpansion() {
      if (this.vettorePBAVisible) {
        this.toggleTableTributoPBAExpansion();
      } else {
        this.toggleTableExpansion();
      }
    },
    toggleCurrentBilancioContoEditMode() {
      if (!this.canUseCurrentBilancioContoEdit) return;
      if (this.vettorePBAVisible) {
        this.toggleEditModePBA();
      } else {
        this.toggleEditModeBA();
      }
    },
    saveCurrentBilancioContoTable() {
      if (!this.currentBilancioContoHasChanges) return;
      this.saveBilancioTable(
        this.currentBilancioContoTableKey,
        this.currentBilancioContoRows
      );
    },
    undoCurrentBilancioContoTable() {
      if (!this.currentBilancioContoCanUndo) return;
      this.undoBilancioTable(
        this.currentBilancioContoTableKey,
        this.currentBilancioContoRows
      );
    },
    resetCurrentBilancioContoTable() {
      if (!this.currentBilancioContoHasChanges) return;
      this.resetBilancioTable(
        this.currentBilancioContoTableKey,
        this.vettorePBAVisible
          ? "vettoreCodContoBA_PDC"
          : "vettoreCodContoBilancioAnalitico"
      );
    },
    toggleCurrentBilancioCFExpansion() {
      if (this.vettoreCFVisible) {
        this.toggleTableCFPDCExpansion();
      } else {
        this.toggleTableCFExpansion();
      }
    },
    toggleCurrentBilancioCFEditMode() {
      if (!this.canUseCurrentBilancioCFEdit) return;
      if (this.vettoreCFVisible) {
        this.toggleEditModeCFPDC();
      } else {
        this.toggleEditModeCF();
      }
    },
    saveCurrentBilancioCFTable() {
      if (!this.currentBilancioCFHasChanges) return;
      this.saveBilancioTable(
        this.currentBilancioCFTableKey,
        this.currentBilancioCFRows
      );
    },
    undoCurrentBilancioCFTable() {
      if (!this.currentBilancioCFCanUndo) return;
      this.undoBilancioTable(
        this.currentBilancioCFTableKey,
        this.currentBilancioCFRows
      );
    },
    resetCurrentBilancioCFTable() {
      if (!this.currentBilancioCFHasChanges) return;
      this.resetBilancioTable(
        this.currentBilancioCFTableKey,
        this.vettoreCFVisible
          ? "vettoreClientiFornitoriPDC"
          : "vettoreClientiFornitori"
      );
    },
    toggleEditModeCF() {
      this.toggleTableEditSession(
        "ba-cf",
        "CLIENTI / FORNITORI INDIVIDUATI",
        this.vettoreClientiFornitori
      );
      this.isEditModeCF = this.isTableEditing("ba-cf");
    },
    toggleEditModeCFPDC() {
      this.toggleTableEditSession(
        "ba-cf-pdc",
        "CLIENTI / FORNITORI GIÀ SALVATI",
        this.vettoreClientiFornitoriPDC
      );
      this.isEditModeCFPDC = this.isTableEditing("ba-cf-pdc");
    },
    handleBilancioCellInput(
      tableKey,
      rowIndex,
      colIndex,
      realColIndex,
      vettore
    ) {
      this.validateInput(rowIndex, colIndex, vettore);
      this.trackTableCellChange(
        tableKey,
        rowIndex,
        realColIndex,
        vettore[rowIndex][realColIndex],
        vettore,
        tableKey === "ba-pdc"
          ? "CODICI CONTO GIÀ SALVATI"
          : "CODICI CONTO INDIVIDUATI"
      );
    },
    handleBilancioCFInput(tableKey, rowIndex, colIndex, vettore, validator) {
      if (typeof validator === "function") validator();
      this.trackTableCellChange(
        tableKey,
        rowIndex,
        colIndex,
        vettore[rowIndex][colIndex],
        vettore,
        tableKey === "ba-cf-pdc"
          ? "CLIENTI / FORNITORI GIÀ SALVATI"
          : "CLIENTI / FORNITORI INDIVIDUATI"
      );
    },
    saveBilancioTable(tableKey, vettore) {
      this.commitTableEditSession(tableKey, vettore);
      if (tableKey === "ba-main") this.isEditModeBA = false;
      if (tableKey === "ba-pdc") this.isEditModePBA = false;
      if (tableKey === "ba-cf") this.isEditModeCF = false;
      if (tableKey === "ba-cf-pdc") this.isEditModeCFPDC = false;
    },
    undoBilancioTable(tableKey, vettore) {
      this.undoLastTableChange(tableKey, ({ rowIndex, colIndex, oldValue }) => {
        this.$set(vettore[rowIndex], colIndex, oldValue);
      });
    },
    resetBilancioTable(tableKey, tableName) {
      if (!this.hasTableChanges(tableKey)) return;
      const label = this.tableEditSessions[tableKey]?.label || "questa tabella";
      this.pendingTableReset = { tableKey, tableName };
      this.resetConfirmContext = "table-reset";
      this.resetConfirmTitle = "Annullare le modifiche?";
      this.resetConfirmEyebrow = "Modifiche tabella";
      this.resetConfirmMessage = `Le modifiche non salvate in ${label} verranno eliminate. Vuoi continuare?`;
      this.resetConfirmConfirmLabel = "Annulla modifiche";
      this.resetConfirmCancelLabel = "Mantieni modifiche";
      this.resetConfirmIconClass = "fa-solid fa-rotate-left";
      this.resetConfirmConfirmIconClass = "fa-solid fa-rotate-left";
      this.showResetConfirmModal = true;
    },
    confirmResetBilancioTable() {
      if (!this.pendingTableReset) return;
      const { tableKey, tableName } = this.pendingTableReset;
      this.resetTableEditSession(tableKey, tableName);
      this.pendingTableReset = null;
    },
    // BLOCCA lettere se c'è già un numero
    blockLetters(event, rowIndex, colKey, colIndex, vettore) {
      const headerName = this.filteredHeaders[colIndex]; // o filteredHeaders
      if (!headerName || !headerName.includes("Cod. Conto")) {
        return; // ← NON fare nulla → permetti tutto
      }
      const currentValue = vettore[rowIndex][colKey] || "";
      const hasNumbers = /\d/.test(currentValue);
      // === Gestione speciale per Backspace/Delete su "N.A." ===
      if (
        currentValue === "N.A." &&
        (event.key === "Backspace" || event.key === "Delete")
      ) {
        event.preventDefault(); // Blocca il comportamento di default
        this.$set(vettore[rowIndex], colKey, ""); // Svuota la cella
        return; // Esci subito
      }
      // Se c'è almeno un numero → BLOCCA tutte le lettere
      if (hasNumbers) {
        const key = event.key;

        // Tasti sempre permessi
        const allowed = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];

        // Ctrl+C, Ctrl+V, Ctrl+A, Ctrl+Z
        if (event.ctrlKey || event.metaKey) return;

        // Se non è numero e non è tasto permesso → BLOCCA
        if (!allowed.includes(key) && !/[0-9]/.test(key)) {
          event.preventDefault();
        }
      }
    },

    // Incolla: prendi solo numeri
    blockPaste(event, colIndex) {
      const headerName =
        this.filteredHeaders[colIndex] ||
        (this.output_PC === "DATEV" ? "Cod. Conto Datev" : "");
      if (!headerName || !headerName.includes("Cod. Conto")) {
        return; // ← incolla tutto
      }
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pasted.replace(/\D/g, "");

      // Inserisci solo i numeri
      const textToInsert = headerName.includes("Datev")
        ? numbersOnly.slice(0, 11)
        : numbersOnly;
      document.execCommand("insertText", false, textToInsert);
    },
    isBAPDCModified() {
      if (!this.originalBA_PDC) return false;
      if (this.vettoreCodContoBA_PDC.length !== this.originalBA_PDC.length)
        return true;

      for (let i = 0; i < this.vettoreCodContoBA_PDC.length; i++) {
        for (let j = 0; j < this.vettoreCodContoBA_PDC[i].length; j++) {
          if (this.vettoreCodContoBA_PDC[i][j] !== this.originalBA_PDC[i][j]) {
            return true;
          }
        }
      }
      return false;
    },
    isClientiFornitoriPDCModified() {
      // Se non abbiamo salvato la copia originale → consideriamo non modificato
      if (!this.originalClientiFornitoriPDC) return false;

      const current = this.vettoreClientiFornitoriPDC;
      const original = this.originalClientiFornitoriPDC;

      // Lunghezza diversa → modificato
      if (current.length !== original.length) return true;

      // Confronto cella per cella (stesso stile di isBAPDCModified)
      for (let i = 0; i < current.length; i++) {
        // Se la riga non esiste o ha lunghezza diversa
        if (
          !Array.isArray(current[i]) ||
          !Array.isArray(original[i]) ||
          current[i].length !== original[i].length
        ) {
          return true;
        }

        for (let j = 0; j < current[i].length; j++) {
          // Confronto con !== (gestisce null, undefined, stringhe, numeri)
          if (current[i][j] !== original[i][j]) {
            return true;
          }
        }
      }

      return false;
    },
    validateInput(rowIndex, colIndex, vettore) {
      const columnName = this.filteredHeaders[colIndex];
      if (!columnName) return;
      if (!columnName.includes("Cod. Conto")) return;

      let value = vettore[rowIndex][this.validColumns[colIndex]];
      if (columnName === "Descrizione codice conto") {
        return;
      }
      // --- NUOVA LOGICA ROBUSTA PER "Nessuno" ---
      // Prendi solo le lettere e verifica se compongono "nessuno" (ignorando numeri e simboli)
      const onlyLetters = (value || "").replace(/[^a-zA-Z]/g, "").toLowerCase();
      if (onlyLetters === "na") {
        // Se ci sono cifre nel valore (anche inserite in mezzo), usale come nuovo valore.
        const onlyNumbers = (value || "").replace(/\D/g, "");
        if (onlyNumbers.length > 0) {
          value = onlyNumbers;
        } else {
          // Non ci sono numeri: tieni esattamente "Nessuno"
          vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
          return;
        }
      }

      // Se dopo aver gestito il caso "Nessuno" il valore contiene ancora lettere,
      // allora è un input letterale non valido -> reset a "Nessuno"
      if (/[a-zA-Z]/.test(value)) {
        vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
        return;
      }
      if (columnName === "Cod. Conto TeamSystem") {
        value = formatBilancioTeamSystemAccountCode(value);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto Sistemi") {
        value = value.replace(/[^0-9]/g, "");

        if (value.length > 2 && value[2] !== ".") {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
        if (value.length > 5 && value[5] !== ".") {
          value = value.slice(0, 5) + "." + value.slice(5);
        }
        if (value.length > 8 && value[8] !== ".") {
          value = value.slice(0, 8) + "." + value.slice(8);
        }

        value = value.slice(0, 12);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto Seac") {
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 6); // Limita a massimo 6 cifre numeriche
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (
        columnName === "Cod. Conto Datev Aziende" ||
        columnName === "Cod. Conto Datev Liberi Prof."
      ) {
        value = value.replace(/\D/g, "").slice(0, 11);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else {
        value = value.replace(/\D/g, "");
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      }
      const finalValue = vettore[rowIndex][this.validColumns[colIndex]] || "";

      let isValid = true;

      if (columnName === "Cod. Conto TeamSystem") {
        isValid =
          !finalValue ||
          finalValue === "N.A." ||
          BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(finalValue);
      } else if (columnName === "Cod. Conto Sistemi") {
        isValid =
          !finalValue ||
          finalValue === "N.A." ||
          /^\d{2}(\.\d{1,3}){0,3}$/.test(finalValue);
      } else if (columnName === "Cod. Conto Seac") {
        isValid =
          !finalValue || finalValue === "N.A." || /^\d{0,6}$/.test(finalValue);
      } else {
        // altri codici conto generici
        isValid =
          !finalValue || finalValue === "N.A." || /^\d+$/.test(finalValue);
      }

      if (isValid) {
        this.clearContoError(rowIndex, colIndex);
      } else {
        this.setContoError(rowIndex, colIndex);
      }
    },
    fillEmptyWithNA() {
      console.log("RIEMPIMENTO N.A. IN CORSO...");

      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];

            if (!value || String(value).trim() === "") {
              if (!col.includes("Nome conto") && !col.includes("Descrizione")) {
                this.$set(row, colIndex, "N.A.");
              }
            }
          });
        });
      };

      // === 1. Vettore principale ===
      fill(this.vettoreCodContoBilancioAnalitico, this.getValidColumns());

      // === 2. Vettore PDC (BA_PDC) ===
      if (this.vettoreCodContoBA_PDC && this.vettoreCodContoBA_PDC.length > 0) {
        const pdcValidCols = this.validColumnsBA_PDC || this.getValidColumns();
        fill(this.vettoreCodContoBA_PDC, pdcValidCols);
      }

      // === 4. Chiudi modale ===
      this.showErrorModal = false;
    },
    fillEmptyWithNoCorr() {
      const fill = (vector, validColumns) => {
        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers[colIndex];
            const value = row[colIndex];
            if (
              col.includes("Nome conto") &&
              (!value || String(value).trim() === "")
            ) {
              this.$set(row, colIndex, "NESSUNA CORRELAZIONE");
            }
          });
        });
      };

      fill(this.vettoreCodContoBilancioAnalitico, this.getValidColumns());
      if (this.vettoreCodContoBA_PDC && this.vettoreCodContoBA_PDC.length > 0) {
        const pdcValidCols = this.validColumnsBA_PDC || this.getValidColumns();
        fill(this.vettoreCodContoBA_PDC, pdcValidCols);
      }

      this.showErrorModal = false;
    },
    validateAllInputs() {
      const validColumns = this.getValidColumns();

      let emptyCells = {
        "Codici Conto mancanti": [],
        "Nomi Conto mancanti": [],
      };

      let formatErrors = [];
      let cfErrors = [];
      let reservedCodContoDefaultCells = [];
      let naCells = [];
      let noCorrCells = [];

      // === REGEX ===
      const teamSystemRegex = BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX;
      const numberRegex = /^\d+$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      // ============================================================
      // === VALIDAZIONE BILANCIO (ESISTENTE - NON MODIFICATA) ===
      // ============================================================

      const validateBilancio = (vector, headers, validCols, prefix = "") => {
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            const cellValue = vector[rowIndex][colIndex];
            const cellStr =
              cellValue === null || cellValue === undefined
                ? ""
                : String(cellValue).trim();

            if (cellStr === "N.A." || cellStr === "NESSUNA CORRELAZIONE") {
              continue;
            }

            if (!cellValue || cellStr === "") {
              if (col.includes("Nome conto")) {
                emptyCells["Nomi Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else {
                emptyCells["Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              }
              continue;
            }

            if (
              !col.includes("Descrizione") &&
              !col.includes("Nome conto") &&
              this.isCodContoDefault(cellStr)
            ) {
              reservedCodContoDefaultCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
              continue;
            }

            if (
              col === "Cod. Conto TeamSystem" &&
              !teamSystemRegex.test(cellValue)
            ) {
              formatErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                }, ${visibleHeader}: formato errato (XX/XX/XXX)`
              );
            }

            if (col === "Cod. Conto Sistemi" && !sistemiRegex.test(cellValue)) {
              formatErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                }, ${visibleHeader}: formato errato (XX.XX.XX o XX.XX.XX.XXX)`
              );
            }

            if (col === "Cod. Conto Seac") {
              const cleaned = cellValue.replace(/[^0-9]/g, "");
              if (!numberRegex.test(cleaned) || cleaned.length !== 6) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${visibleHeader}: deve contenere esattamente 6 cifre`
                );
              }
            }

            if (
              [
                "Cod. Conto Datev Aziende",
                "Cod. Conto Datev Liberi Prof.",
              ].includes(col)
            ) {
              if (!numberRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${visibleHeader}: deve essere un numero intero`
                );
              } else if (cellValue.length < 5 || cellValue.length > 11) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${visibleHeader}: deve contenere da 5 a 11 cifre`
                );
              }
            }

            if (
              col === "Cod. Conto Zucchetti" &&
              !numberRegex.test(cellValue)
            ) {
              formatErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                }, ${visibleHeader}: deve essere un numero intero`
              );
            }
          }
        }

        // --- Rileva N.A. e NESSUNA CORRELAZIONE ---
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i];
            const col = this.headers[colIndex];
            const cellValue = vector[rowIndex][colIndex];
            const cellStr = String(cellValue).trim().toUpperCase();

            if (
              !col.includes("Descrizione") &&
              !col.includes("Nome conto") &&
              cellStr === "N.A."
            ) {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }

            if (
              col.includes("Nome conto") &&
              cellStr === "NESSUNA CORRELAZIONE"
            ) {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // ============================================================
      // === NUOVA VALIDAZIONE CLIENTI / FORNITORI ===
      // ============================================================

      const validateClientiFornitori = (vector, prefix = "") => {
        if (!vector || vector.length === 0) return;

        const software = (this.output_PC || "").trim().toUpperCase();

        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          const row = vector[rowIndex];

          const conto = (row[4] || "").trim();
          const cf = (row[5] || "").trim().toUpperCase();
          const anag = (row[6] || "").trim();

          // === COD. CONTO SOFTWARE ===
          if (!conto) {
            cfErrors.push(
              `${prefix}Riga ${rowIndex + 1} - Cod. Conto Software mancante`
            );
          } else {
            if (this.isCodContoDefault(conto)) {
              reservedCodContoDefaultCells.push(
                `${prefix}Riga ${rowIndex + 1} - Cod. Conto Software`
              );
              continue;
            }

            if (software === "TEAMSYSTEM" && !teamSystemRegex.test(conto)) {
              cfErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                } - Cod. Conto Software: formato errato (XX/XX/XXX)`
              );
            }

            if (software === "SISTEMI" && !sistemiRegex.test(conto)) {
              cfErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                } - Cod. Conto Software: formato errato`
              );
            }

            if (software === "SEAC") {
              const cleaned = conto.replace(/\D/g, "");
              if (!numberRegex.test(cleaned) || cleaned.length !== 6) {
                cfErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  } - Cod. Conto Software: deve contenere 6 cifre`
                );
              }
            }
          }

          // === CF ===
          if (!cf) {
            cfErrors.push(
              `${prefix}Riga ${rowIndex + 1} - Codice Fiscale mancante`
            );
          } else {
            const isPiva = /^\d{11}$/.test(cf);
            const isCF = /^[A-Z0-9]{16}$/.test(cf);

            if (!isPiva && !isCF) {
              cfErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                } - Codice Fiscale: 11 cifre o 16 caratteri alfanumerici`
              );
            }
          }

          // === CODICE ANAGRAFICA ===
          if (!anag) {
            cfErrors.push(
              `${prefix}Riga ${rowIndex + 1} - Codice Anagrafica mancante`
            );
          } else {
            const numeri = anag.replace(/\D/g, "");
            if (numeri.length < 4) {
              cfErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                } - Codice Anagrafica: almeno 4 cifre`
              );
            }
          }
        }
      };

      // === ESECUZIONE VALIDAZIONI ===

      validateBilancio(
        this.vettoreCodContoBilancioAnalitico,
        this.filteredHeaders,
        validColumns
      );

      if (this.vettoreCodContoBA_PDC?.length > 0) {
        validateBilancio(
          this.vettoreCodContoBA_PDC,
          this.filteredHeaders,
          this.validColumnsBA_PDC || validColumns,
          "[SALVATI] "
        );
      }

      validateClientiFornitori(this.vettoreClientiFornitori);

      if (this.vettoreClientiFornitoriPDC?.length > 0) {
        validateClientiFornitori(this.vettoreClientiFornitoriPDC, "[SALVATI] ");
      }

      // ============================================================
      // === REPORTING ERRORI BLOCCANTI ===
      // ============================================================

      const detectedErrors = [];
      const codiciContoSection = "CODICI CONTO INDIVIDUATI";
      const clientiFornitoriSection = "CLIENTI / FORNITORI";

      if (emptyCells["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "empty-cells",
          title: "Codici Conto mancanti:",
          messages: emptyCells["Codici Conto mancanti"],
        });
      }

      if (emptyCells["Nomi Conto mancanti"].length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "empty-cells",
          title: "Nomi Conto mancanti:",
          messages: emptyCells["Nomi Conto mancanti"],
        });
      }

      if (formatErrors.length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "format-errors",
          title: "Codici conto non validi:",
          messages: formatErrors,
        });
      }

      if (reservedCodContoDefaultCells.length > 0) {
        detectedErrors.push({
          section: codiciContoSection,
          type: "format-errors",
          title: `Codice conto ${this.codContoDefault} riservato:`,
          messages: reservedCodContoDefaultCells,
        });
      }

      if (cfErrors.length > 0) {
        detectedErrors.push({
          section: clientiFornitoriSection,
          type: "cf-errors",
          title: "Errori Clienti / Fornitori:",
          messages: cfErrors,
        });
      }

      if (detectedErrors.length > 0) {
        this.errorsData = detectedErrors;
        this.showErrorModal = true;
        return false;
      }

      return true;
    },

    validaContoSoftware(rowIndex, vettore) {
      let value = (vettore[rowIndex][4] || "").trim();
      const software = (this.output_PC || "").trim();

      if (!value) {
        vettore[rowIndex][4] = "";
        this.clearContoSoftwareError(rowIndex);
        return;
      }

      // Pulizia preventiva (per paste o eventuali caratteri strani)
      // Rimuoviamo tutto ciò che non è numero o separatore consentito
      value = value.replace(/[^0-9/.]/g, "");

      // FORMATTAZIONE PER SOFTWARE (invariata)
      if (software === "TEAMSYSTEM") {
        value = formatBilancioTeamSystemAccountCode(value);
      } else if (software === "SISTEMI") {
        value = value.replace(/[^0-9]/g, "");
        if (value.length > 2) value = value.slice(0, 2) + "." + value.slice(2);
        if (value.length > 5) value = value.slice(0, 5) + "." + value.slice(5);
        if (value.length > 8) value = value.slice(0, 8) + "." + value.slice(8);
        value = value.slice(0, 12);
      } else if (software === "SEAC") {
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 6);
      } else if (software === "DATEV") {
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 11);
      } else {
        // Datev, Zucchetti, TeamSystem Enterprise, altri
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 20);
      }

      vettore[rowIndex][4] = value;

      // VALIDAZIONE FINALE (N.A. NON ESISTE PIÙ)
      const finalValue = vettore[rowIndex][4] || "";

      let isValid = true;

      if (software === "TEAMSYSTEM") {
        isValid =
          !finalValue || BILANCIO_TEAMSYSTEM_ACCOUNT_REGEX.test(finalValue);
      } else if (software === "SISTEMI") {
        isValid = !finalValue || /^\d{2}(\.\d{1,3}){0,3}$/.test(finalValue);
      } else if (software === "SEAC") {
        isValid = !finalValue || /^\d{0,6}$/.test(finalValue);
      } else if (software === "DATEV") {
        isValid = !finalValue || /^\d{1,11}$/.test(finalValue);
      } else {
        isValid = !finalValue || /^\d{1,20}$/.test(finalValue);
      }

      if (this.isCodContoDefault(finalValue)) {
        isValid = false;
      }

      if (isValid) {
        this.clearContoSoftwareError(rowIndex);
      } else {
        this.setContoSoftwareError(rowIndex);
      }
    },

    validaCFPIVA(event, index) {
      const val = (event.target.value || "").trim().toUpperCase();
      this.$set(this.errorsCF, index, null);

      if (!val) return;

      // Tabelle per il controllo del check digit del Codice Fiscale
      const DISPARI = {
        0: 1,
        1: 0,
        2: 5,
        3: 7,
        4: 9,
        5: 13,
        6: 15,
        7: 17,
        8: 19,
        9: 21,
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
      };

      const PARI = {
        0: 0,
        1: 1,
        2: 2,
        3: 3,
        4: 4,
        5: 5,
        6: 6,
        7: 7,
        8: 8,
        9: 9,
        A: 0,
        B: 1,
        C: 2,
        D: 3,
        E: 4,
        F: 5,
        G: 6,
        H: 7,
        I: 8,
        J: 9,
        K: 10,
        L: 11,
        M: 12,
        N: 13,
        O: 14,
        P: 15,
        Q: 16,
        R: 17,
        S: 18,
        T: 19,
        U: 20,
        V: 21,
        W: 22,
        X: 23,
        Y: 24,
        Z: 25,
      };
      // Caso PARTITA IVA
      if (/^\d{11}$/.test(val)) {
        let sum = 0;

        for (let i = 0; i < 10; i++) {
          let digit = parseInt(val[i], 10);

          if (i % 2 === 1) {
            // posizione dispari
            digit *= 2;
            if (digit > 9) digit -= 9;
          }

          sum += digit;
        }

        const checkDigit = (10 - (sum % 10)) % 10;

        if (checkDigit === parseInt(val[10], 10)) return;

        this.$set(this.errorsCF, index, true);
        return;
      }

      // Caso CF
      if (val.length !== 16 || !/^[A-Z0-9]{16}$/.test(val)) {
        this.$set(this.errorsCF, index, true);
        return;
      }

      let sum = 0;
      for (let i = 0; i < 15; i++) {
        const char = val[i];
        const pos = i % 2 === 0 ? DISPARI[char] : PARI[char];
        sum += pos;
      }

      const expectedCheck = String.fromCharCode(65 + (sum % 26));
      const realCheck = val[15];

      if (expectedCheck !== realCheck) {
        this.$set(this.errorsCF, index, true);
      }
    },

    validaCodAnagrafica(event, index) {
      const val = (event.target.value || "").trim();

      this.$set(this.errorsAnag, index, null);

      if (!val) return;

      const numeri = val.replace(/\D/g, "");
      if (numeri.length < 4) {
        this.$set(this.errorsAnag, index, true);
        // oppure messaggio completo se serve dopo
        // this.$set(this.errorsAnag, index, "Almeno 4 cifre numeriche");
      }
    },
    hasContoSoftwareError(rowIndex) {
      return !!this.errorsContoSoftware[rowIndex];
    },

    setContoSoftwareError(rowIndex) {
      this.$set(this.errorsContoSoftware, rowIndex, true);
    },

    clearContoSoftwareError(rowIndex) {
      this.$delete(this.errorsContoSoftware, rowIndex);
    },
    hasContoError(rowIndex, colIndex) {
      return !!this.errorsConto[`${rowIndex}-${colIndex}`];
    },

    setContoError(rowIndex, colIndex) {
      this.$set(this.errorsConto, `${rowIndex}-${colIndex}`, true);
    },

    clearContoError(rowIndex, colIndex) {
      this.$delete(this.errorsConto, `${rowIndex}-${colIndex}`);
    },
    proceedWithWarnings() {
      this.naConfirmed = true;
      this.noCorrConfirmed = true;
      this.showErrorModal = false;
      this.fase_3_bilancio();
    },
    initializeBilancioDateInputs(clienti = []) {
      this.dateBilancioInputs = {};
      clienti.forEach((cliente, index) => {
        const dataEstratta = this.getData(cliente?.[1]);
        this.$set(
          this.dateBilancioInputs,
          index,
          this.formatDateBilancioForInput(dataEstratta)
        );
      });
    },
    splitBilancioTitle(testo) {
      if (!testo) {
        return { nome: "", codiceFiscale: "", data: "" };
      }

      const parti = String(testo)
        .split(" - ")
        .map((parte) => parte.trim());

      if (parti.length === 2) {
        return {
          nome: parti[0] || "",
          codiceFiscale: "",
          data: parti[1] || "",
        };
      }

      return {
        nome: parti[0] || "",
        codiceFiscale: parti[1] || "",
        data: parti[parti.length - 1] || "",
      };
    },
    formatDateBilancioForInput(dataTestuale) {
      if (!dataTestuale) return "";

      const valore = String(dataTestuale).trim();
      const matchSlash = valore.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (matchSlash) {
        const [, giorno, mese, anno] = matchSlash;
        return `${giorno.padStart(2, "0")}/${mese.padStart(2, "0")}/${anno}`;
      }

      const mesi = {
        gennaio: "01",
        febbraio: "02",
        marzo: "03",
        aprile: "04",
        maggio: "05",
        giugno: "06",
        luglio: "07",
        agosto: "08",
        settembre: "09",
        ottobre: "10",
        novembre: "11",
        dicembre: "12",
      };

      const matchTesto = valore.match(/^(\d{1,2})\s+([A-Za-zÀ-ÿ]+)\s+(\d{4})$/);
      if (!matchTesto) return valore;

      const [, giorno, meseTesto, anno] = matchTesto;
      const mese = mesi[meseTesto.toLowerCase()];
      if (!mese) return valore;

      return `${giorno.padStart(2, "0")}/${mese}/${anno}`;
    },
    handleDateBilancioInput(index, valore) {
      const precedente = String(this.dateBilancioInputs[index] || "");
      const pulita = String(valore || "")
        .replace(/[^\d/]/g, "")
        .slice(0, 10);

      const isDeletion = pulita.length < precedente.length;
      const isAppendInCoda = !isDeletion && pulita.startsWith(precedente);

      if (isDeletion || !isAppendInCoda) {
        this.$set(this.dateBilancioInputs, index, pulita);
        return;
      }

      const digits = pulita.replace(/\//g, "").slice(0, 8);
      let formattata = digits;

      if (digits.length === 2) {
        formattata = `${digits}/`;
      } else if (digits.length > 2 && digits.length < 5) {
        formattata = `${digits.slice(0, 2)}/${digits.slice(2)}`;
      } else if (digits.length === 4) {
        formattata = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/`;
      } else if (digits.length > 4) {
        formattata = `${digits.slice(0, 2)}/${digits.slice(
          2,
          4
        )}/${digits.slice(4)}`;
      }

      this.$set(this.dateBilancioInputs, index, formattata);
    },
    normalizeDateBilancioInput(valore) {
      const pulita = String(valore || "")
        .replace(/[^\d/]/g, "")
        .trim();

      if (!pulita) return "";

      if (/^\d{8}$/.test(pulita)) {
        return `${pulita.slice(0, 2)}/${pulita.slice(2, 4)}/${pulita.slice(4)}`;
      }

      const match = pulita.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (!match) {
        return pulita;
      }

      const [, giorno, mese, anno] = match;
      return `${giorno.padStart(2, "0")}/${mese.padStart(2, "0")}/${anno}`;
    },
    isValidDateBilancio(valore) {
      const dataNormalizzata = this.normalizeDateBilancioInput(valore);
      if (!dataNormalizzata) return false;

      const match = dataNormalizzata.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match) return false;

      const [, giornoStr, meseStr, annoStr] = match;
      const giorno = Number(giornoStr);
      const mese = Number(meseStr);
      const anno = Number(annoStr);
      const data = new Date(anno, mese - 1, giorno);

      return (
        data.getFullYear() === anno &&
        data.getMonth() === mese - 1 &&
        data.getDate() === giorno
      );
    },
    shouldShowInvalidDateBilancio(valore) {
      const dataNormalizzata = this.normalizeDateBilancioInput(valore);
      return !!dataNormalizzata && dataNormalizzata.length === 10
        ? !this.isValidDateBilancio(dataNormalizzata)
        : false;
    },
    convertDateBilancioToText(valore) {
      if (!this.isValidDateBilancio(valore)) return "";

      const [, giorno, mese, anno] = valore.match(
        /^(\d{2})\/(\d{2})\/(\d{4})$/
      );
      const mesi = [
        "",
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ];

      return `${giorno} ${mesi[Number(mese)]} ${anno}`;
    },
    syncBilancioClienteTitle(cliente, index) {
      if (!cliente) return;

      const titoloCorrente = this.splitBilancioTitle(cliente[1]);
      const denominazione = (cliente[3] || titoloCorrente.nome || "").trim();
      const codiceFiscale = (
        cliente[4] ||
        titoloCorrente.codiceFiscale ||
        ""
      ).trim();

      const dataInput = (this.dateBilancioInputs[index] || "").trim();
      const dataTestuale = this.isValidDateBilancio(dataInput)
        ? this.convertDateBilancioToText(dataInput)
        : titoloCorrente.data;

      this.$set(
        cliente,
        1,
        `${denominazione} - ${codiceFiscale} - ${dataTestuale}`.trim()
      );
    },
    commitDateBilancio(index) {
      const valore = this.normalizeDateBilancioInput(
        this.dateBilancioInputs[index]
      );
      if (!valore || !this.isValidDateBilancio(valore)) {
        return;
      }

      this.$set(this.dateBilancioInputs, index, valore);

      const cliente = this.vettoreClienti[index];
      if (!cliente) return;

      this.syncBilancioClienteTitle(cliente, index);
    },
    normalizeBilancioClientTitles() {
      for (let index = 0; index < this.vettoreClienti.length; index += 1) {
        const valore = this.normalizeDateBilancioInput(
          this.dateBilancioInputs[index]
        );
        if (!this.isValidDateBilancio(valore)) {
          return false;
        }

        this.$set(this.dateBilancioInputs, index, valore);
        this.syncBilancioClienteTitle(this.vettoreClienti[index], index);
      }

      return true;
    },
    formattaCFPI(event, cliente, index) {
      let valore = event.target.value
        .replace(/[^0-9A-Za-z]/g, "")
        .toUpperCase();

      this.$set(cliente, 4, valore);
      this.syncBilancioClienteTitle(cliente, index);

      // riposizionamento cursore opzionale
      this.$nextTick(() => {
        event.target.value = valore;
        event.target.setSelectionRange(valore.length, valore.length);
      });
    },

    isValidCodiceFiscale(val) {
      if (!val) return true; // vuoto → ok (non obbligatorio)
      return validFiscalCode(val);
    },
    selezionaColonna(tipo) {
      if (tipo === 1 || tipo === 2) {
        // SEAC: Contabilità Ordinaria (1) o Semplificata (2)
        const tuttiSelezionati = this.vettoreClienti_SEAC.every(
          (cliente) => cliente[2] === tipo
        );
        this.vettoreClienti_SEAC = this.vettoreClienti_SEAC.map((cliente) => {
          const newCliente = [...cliente];
          newCliente[2] = tuttiSelezionati ? null : tipo; // null per deselezionare
          return newCliente;
        });
      } else if (tipo === 3 || tipo === 4) {
        // DATEV: Aziende (3) o Liberi Professionisti (4), mappa su 1 e 2
        const valore = tipo === 3 ? 1 : 2; // Mappa tipo 3->1, tipo 4->2
        const tuttiSelezionati = this.vettoreClienti.every(
          (cliente) => cliente[2] === valore
        );
        this.vettoreClienti = this.vettoreClienti.map((cliente) => {
          const newCliente = [...cliente];
          newCliente[2] = tuttiSelezionati ? null : valore; // null per deselezionare
          return newCliente;
        });
      }
    },
    getNome(testo) {
      if (!testo) return "";
      const parti = testo.split(" - ");
      return parti[0]?.trim() || "";
    },

    getData(testo) {
      if (!testo) return "";
      const parti = testo.split(" - ");
      return parti[parti.length - 1]?.trim() || "";
    },
    hasNessunaCorrelazione(value) {
      if (typeof value === "string") {
        return value.toLowerCase().includes("nessuna correlazione");
      }
      return false;
    },
    isNessuno(value) {
      return value === "N.A.";
    },
    toggleTableExpansion() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    toggleTableTributoPBAExpansion() {
      this.isTablePBAExpanded = !this.isTablePBAExpanded;
    },
    toggleTableCFExpansion() {
      this.isTableCFExpanded = !this.isTableCFExpanded;
    },
    toggleTableCFPDCExpansion() {
      this.isTableCFPDCExpanded = !this.isTableCFPDCExpanded;
    },
    async handleDownload(event) {
      event.preventDefault();

      if (!this.confermaConversione) {
        this.errorMessage = "Devi confermare il numero di conversioni!";
        return;
      }

      try {
        const response = await axios.post(
          `${API_BASE_URL}/conversion_jobs/${this.jobId}/download`,
          null,
          { responseType: "blob" }
        );
        this.hasDownloaded = true;
        this.fetchConversionCount();

        // Crea link per scaricare il blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.fileName);
        document.body.appendChild(link);
        link.click();
        this.hasOutputDownloadStarted = true;
        link.remove();
        window.URL.revokeObjectURL(url);

        // Invia log dopo download
        await axios.post(`${API_BASE_URL}/log_download`, {
          job_id: this.jobId,
          file_name: this.selectedFile
            ? this.selectedFile.name
            : "file_sconosciuto",
          output_file_name: this.filePath,
          output_display_name: this.fileName,
          file_scaricati: this.filesNames ? this.filesNames : [],
          operazione: "Conversione Bilancio Analitico",
        });
        this.removePersistedJobState();
      } catch (error) {
        this.errorMessage =
          error.response?.status === 402
            ? "Coin non sufficienti per scaricare il file."
            : "Errore durante il processo di download.";
        console.error("Errore nel handleDownload:", error);
      }
    },

    // Metodo per ottenere il contatore delle conversioni dal backend
    fetchConversionCount() {
      axios
        .get(`${API_BASE_URL}/get_conversion_count`)
        .then((response) => {
          this.creditiDisponibili = response.data.crediti_disponibili;
        })
        .catch((error) => {
          console.error("Errore nel recupero del contatore:", error);
        });
    },
    fetchPrezziConversione() {
      axios
        .get(`${API_BASE_URL}/getPrezziConversione`)
        .then((response) => {
          this.creditiPerBilancio = response.data.crediti_per_bilancio;
        })
        .catch((error) => {
          console.error("Errore nel recupero dei prezzi conversione:", error);
        });
    },
    startDelayMessageTimer() {
      this.delayTimer = setTimeout(() => {
        this.showDelayedMessage = true;
      }, 10000);
      // Cambia il testo dopo 30 secondi totali
      this.updateTimer = setTimeout(() => {
        this.delayedMessageUpdated = true;
      }, 30000);
    },
    clearDelayMessageTimer() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.updateTimer);
      this.showDelayedMessage = false;
      this.delayedMessageUpdated = false;
    },
    loadSettings() {
      const loaded = getUserSettings();

      // Merge sicuro: sovrascrive i default con i valori reali (se presenti)
      this.settings = {
        ...this.settings, // mantiene i default se qualcosa manca
        ...loaded,
      };

      // Dopo aver caricato le settings, applica le preferenze specifiche
      this.applySoftwarePreference();
      this.applyDettaglioFornitoriPreference();
      this.applyCFPIVAPreference();

      console.log("Tutte le impostazioni caricate:", this.settings);
    },

    // Metodo separato solo per applicare la preferenza software
    // (lo teniamo separato per chiarezza, ma potrebbe anche stare dentro loadAllSettings)
    applySoftwarePreference() {
      const saved = this.settings.software_contabile || "default";

      const mapping = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SISTEMI: "SISTEMI",
        SEAC: "SEAC",
      };

      if (mapping[saved]) {
        this.output_PC = mapping[saved];
      }
    },
    applyDettaglioFornitoriPreference() {
      if (this.settings.flag_dettClientiFornitori) {
        this.flag_dettClientiFornitori = true;
      }
    },
    applyCFPIVAPreference() {
      if (this.settings.flag_CFPIVA) {
        this.flag_CFPIVA = true;
      }
    },
    nextSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex < phases.length - 1) {
        this.closeBilancioContoViewDropdown();
        this.closeBilancioCFViewDropdown();
        this.currentSubPhase = phases[currentIndex + 1];
      }
    },
    prevSubPhase() {
      const phases = this.availablePhases;
      const currentIndex = phases.indexOf(this.currentSubPhase);
      if (currentIndex > 0) {
        this.closeBilancioContoViewDropdown();
        this.closeBilancioCFViewDropdown();
        this.currentSubPhase = phases[currentIndex - 1];
      }
    },
  },
  created() {
    this.userEmail = localStorage.getItem("userEmail");
  },
  async mounted() {
    this.fetchConversionCount();
    this.fetchPrezziConversione();
    this.loadSettings();
    await this.resumeStoredJob();
    await this.cleanupPurgeableJobs();
    document.addEventListener("click", this.closeBilancioContoViewDropdown);
    document.addEventListener("click", this.closeBilancioCFViewDropdown);
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.addEventListener("pagehide", this.handleWindowPageHide);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeBilancioContoViewDropdown);
    document.removeEventListener("click", this.closeBilancioCFViewDropdown);
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
    window.removeEventListener("pagehide", this.handleWindowPageHide);
    this.stopJobPolling();
  },
  beforeRouteLeave(to, from, next) {
    if (this.shouldConfirmReset()) {
      this.openConversionInterruptModal("leave", next);
      return;
    }

    const finalize = async () => {
      if (!this.jobId) return;
      if (this.isPollableJobStatus(this.jobStatus)) {
        await this.cancelActiveJob(false);
        return;
      }
      await this.cleanupSpecificJob(this.jobId);
      await this.cleanupPurgeableJobs();
      this.clearJobState();
    };

    finalize().finally(() => next());
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  min-height: 10rem;
  background: white;
  border-radius: 12px;
  width: calc(100vw - 2rem);
  max-width: 66rem;
  min-width: 0;
  padding: 1rem;
  box-sizing: border-box;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: modalFadeIn 0.3s ease;
  max-height: calc(100vh - 2rem);
  overflow: auto;
}

.modal-content :deep(.store-card),
.modal-content :deep(.skeleton-loader) {
  margin: 0 auto;
}

.modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.7rem;
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
  color: #666;
}

.modal-close:hover {
  color: #000;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.italic-text {
  font-style: italic;
  font-size: 0.75rem;
  color: rgb(156, 156, 156);
}
.titleConvBilanci {
  color: #4a4033;
}
.contenitore-bilancio .action-button {
  background: linear-gradient(135deg, #6f6045, #4f4638);
}
.contenitore,
.headersButtonsbilancio {
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgba(223, 223, 223, 0.82) !important;
}
.headersButtonsbilancio .tool-button i,
.headersButtonsbilancio i {
  color: #7b6a4b;
}
.headersButtonsbilancio .tool-button i:hover,
.headersButtonsbilancio i:hover {
  color: #5a4010 !important;
}
.select-input {
  margin-bottom: 1.5rem;
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.checkboxversionestesa:disabled {
  cursor: default;
}
.input-editable {
  width: 90%;
  min-height: 1.65rem;
  padding: 0.24rem 0.46rem;
  border: 1px solid #cfd8e3;
  border-radius: 6px;
  background: #ffffff;
  font-size: 0.9em;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input-editable:focus {
  border-color: #7aa7d9;
  outline: none;
  box-shadow: 0 0 0 2px rgba(35, 103, 173, 0.14);
}

.input-valorizzato {
  background: #f8f9fa;
  color: #333;
  border-color: #adb5bd;
  cursor: default;
}
.input-valorizzato:focus {
  outline: none;
}
.invalid-input {
  border-color: #e74c3c !important;
  background-color: #fff5f5;
}
.btnPBAvisible {
  width: 13.8rem;
}

.result-container--bilancio-analitico .fase2 {
  height: 100%;
}

.bilancio-fase2-response {
  position: relative;
  height: 100%;
  max-height: none;
  overflow: hidden;
  padding-bottom: 4.7rem;
  box-sizing: border-box;
}

.bilancio-fase2-response .title-conv {
  margin-top: 0.9rem;
  margin-bottom: 0.95rem;
}

.bilancio-fase2-response .bilancio-table-dashboard {
  position: relative;
  z-index: 1002;
  width: calc(100% - 1rem);
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 0;
}

.bilancio-fase2-response .cod_conto_table_div,
.bilancio-fase2-response .cod_conto_table_divPBA {
  width: calc(100% - 1rem);
  box-sizing: border-box;
  margin-right: auto;
  margin-left: auto;
  max-height: clamp(18rem, 43dvh, 31rem);
  border: 1px solid #dce5eb;
  border-top: 0;
  border-radius: 0 0 10px 10px;
  background: #fff;
}

.bilancio-fase2-response .divPBAtable:not(.table-hidden) {
  max-height: clamp(18rem, 43dvh, 31rem);
  overflow: visible;
}

.bilancio-fase2-response.dashboard-table-expanded {
  position: absolute;
  inset: 0;
  z-index: 998;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #fff;
  border-radius: 5px;
}

.bilancio-fase2-response.dashboard-table-expanded .title-conv {
  display: none;
}

.bilancio-fase2-response.dashboard-table-expanded .bilancio-table-dashboard {
  flex: 0 0 auto;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.bilancio-subphase-content,
.bilancio-table-pane {
  min-height: 0;
}

.bilancio-fase2-response.dashboard-table-expanded .bilancio-subphase-content,
.bilancio-fase2-response.dashboard-table-expanded .bilancio-table-pane {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
}

.bilancio-fase2-response.dashboard-table-expanded
  .divPBAtable:not(.table-hidden) {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow: hidden;
}

.bilancio-fase2-response.dashboard-table-expanded .cod_conto_table_div,
.bilancio-fase2-response.dashboard-table-expanded .cod_conto_table_divPBA,
.bilancio-fase2-response.dashboard-table-expanded .cod_conto_table_div.expanded,
.bilancio-fase2-response.dashboard-table-expanded
  .cod_conto_table_divPBA.expanded {
  position: relative;
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
  flex: 1 1 auto;
  width: 100%;
  height: auto;
  min-height: 0;
  max-height: none;
  margin-right: auto;
  margin-left: auto;
  z-index: 1;
  overflow: auto;
}

.bilancio-fase2-response.dashboard-table-expanded .subphase-navigation {
  display: none;
}

.bilancio-fase2-response .codconto-table-dashboard + div {
  margin-top: 0;
}

.bilancio-fase2-response .subphase-navigation {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 4.25rem;
  margin-top: 0;
  pointer-events: none;
}

.bilancio-fase2-response .subphase-navigation button {
  pointer-events: auto;
}

.bilancio-fase2-response .btnfase2 {
  bottom: 0.45rem;
}

.bilancio-fase2-response .prev-subphase-btn,
.bilancio-fase2-response .next-subphase-btn {
  bottom: 0.65rem;
}
</style>
